import React, { useState, useRef, useEffect, useMemo } from 'react';
import {
    Search,
    Funnel,
    Edit2,
    Plus,
    MoreHorizontal,
    ChevronsUpDown,
    ChevronLeft,
    ChevronRight,
    X,
    Copy,
    SquareArrowOutUpRight,
    CircleCheck,
    ChevronUp, ChevronDown,
    FunnelPlus
} from 'lucide-react';
import { useHistory, useLocation } from "react-router-dom";
import apiHelper from '../../apiHelper';
import noImage from '../../assets/img/brand/noImage.png';
import noBrandImage from '../../assets/img/brand/no-brand-img.png';
import emptySearchImg from '../../assets/img/brand/empty-search.png';
import ConfirmDeactivateModal from '../../components/ConfirmDeactivateModal';
import ConfirmArchiveModal from '../../components/ConfirmArchiveModal';
import { useLoader } from '../../components/GlobalLoader';
import SortableHeader from '../../components/SortableHeader';
import AlertNotification from '../../components/AlertNotification';
import Pagination from '../../components/Pagination';
import SearchBox from '../../components/SearchBox';
import DynamicTable from '../../components/DynamicTable';
import { formatDateTime } from '../../utils/formateDate';

const PAGE_SIZE = 10; // Display all 10 rows on one page

export default function Brand() {
    const [activeTab, setActiveTab] = useState('brands');
    const [brandsData, setBrandsData] = useState([]);
    const [allBrandsForFilter, setAllBrandsForFilter] = useState([]);
    const history = useHistory();
    const location = useLocation();
    const filterButtonRef = useRef(null);
    const filterPopupRef = useRef(null);
    const [filterPopupOpen, setFilterPopupOpen] = useState(false);
    const [searchStatus, setSearchStatus] = useState([]);
    const [ParentBrand, setParentBrand] = useState([]);
    const breadcrumbs = ["Product", "Brand"];
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedIds, setSelectedIds] = useState([]);
    const [archivedSearchTerm, setArchivedSearchTerm] = useState('');
    const [archivedCurrentPage, setArchivedCurrentPage] = useState(1);
    const [archivedSelectedIds, setarchivedSelectedIds] = useState([]);
    const [archivedBrands, setArchivedBrands] = useState([]);
    const [suppressHighlight, setSuppressHighlight] = useState(false);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [drawerTab, setDrawerTab] = useState('general');
    const [selectedRow, setSelectedRow] = useState(null);
    const [selectedStatuses, setSelectedStatuses] = useState([]);
    const [selectedParentBrands, setSelectedParentBrands] = useState([]);
    const [filterPosition, setFilterPosition] = useState({ top: 0, left: 0 });
    const [parentSearchTerm, setParentSearchTerm] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [totalCount, setTotalCount] = useState(0);
    const [archivedTotalCount, setArchivedTotalCount] = useState(0);
    const [dropdownOpenId, setDropdownOpenId] = useState(null);
    const dropdownRef = useRef(null);
    const buttonRefs = useRef({});
    const drawerRef = useRef(null);
    const currentRow = brandsData.find(e => e.brand_id === dropdownOpenId);
    const [toolbarDropdownOpen, setToolbarDropdownOpen] = useState(false);
    const toolbarRef = useRef(null);
    const [openId, setOpenId] = useState('');
    const [copied, setCopied] = useState(false);
    const archivedRef = useRef(null);
    const [archivedModalOpen, setArchivedModalOpen] = useState(false);
    const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
    const [selectedBrandId, setSelectedBrandId] = useState(null);
    const [successMessage, setSuccessMessage] = useState('');
    const [validationError, setValidationError] = useState([]);
    const parentBrandRef = useRef(null);
    const [isParentBrandOpen, setIsParentBrandOpen] = useState(false);
    const [sortField, setSortField] = useState(null);
    const [sortOrder, setSortOrder] = useState('asc'); // 'asc' or 'desc'
    const archivedFilterButtonRef = useRef(null);
    const archivedFilterPopupRef = useRef(null);
    const [archivedFilterPopupOpen, setArchivedFilterPopupOpen] = useState(false);
    const [archivedFilterPosition, setArchivedFilterPosition] = useState({ top: 0, left: 0 });
    const [archivedSearchParentBrand, setArchivedSearchParentBrand] = useState([]);
    const [archivedParentBrandSearchTerm, setArchivedParentBrandSearchTerm] = useState('');
    const archivedFilterCount = [...archivedSearchParentBrand].filter(Boolean).length;
    const [searchParentBrand, setSearchParentBrand] = useState([]);
    const [imageModalOpen, setImageModalOpen] = useState(false);
    const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
    const saveRef = useRef(null);
    const [saveModalOpen, setSaveModalOpen] = useState(false);
    const [previousBrand, setPreviousBrand] = useState(null);
    const [deactivateModalOpen, setDeactivateModalOpen] = useState(false);
    const [spuLinkedModalOpen, setSpuLinkedModalOpen] = useState(false);
    const [linkedModalMessage, setLinkedModalMessage] = useState("");
    const filterCount = [...selectedStatuses, ...selectedParentBrands].filter(Boolean).length;
    const { showLoader, hideLoader } = useLoader();
    const [searchInput, setSearchInput] = useState('');
    const [archivedSearchInput, setArchivedSearchInput] = useState('');
    const [tempStatuses, setTempStatuses] = useState([]);
    const [tempParentBrands, setTempParentBrands] = useState([]);
    const [tempArchivedParentBrand, setTempArchivedParentBrand] = useState([]);
    const [tempArchivedParentBrands, setTempArchivedParentBrands] = useState([]);
    const [isHovered, setIsHovered] = React.useState(false);
    const [parentBrandDropdownOpen, setParentBrandDropdownOpen] = useState(false);
    const [archivedParentBrandDropdownOpen, setArchivedParentBrandDropdownOpen] = useState(false);
    const [ignoreOutsideClick, setIgnoreOutsideClick] = useState(false);
    const parentDropdownRef = useRef(null);
    const archivedDropdownRef = useRef(null);
    const [brandStack, setBrandStack] = useState([]);
    const [debouncedBrandSearch, setDebouncedBrandSearch] = useState('');
    const [debouncedArchivedBrandSearch, setDebouncedArchivedBrandSearch] = useState('');
    const isFirstBrandLoad = useRef(true);
    const isFirstBrandSearchRender = useRef(true);
    const isFirstArchivedBrandSearchRender = useRef(true);
    const isFirstBrandFilterRender = useRef(true);
    const isFirstArchivedBrandFilterRender = useRef(true);
    const prefetchCache = useRef(new Map());
    const prefetchInProgress = useRef(new Set());
    const archivedPrefetchCache = useRef(new Map());
    const archivedPrefetchInProgress = useRef(new Set());
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                archivedParentBrandDropdownOpen &&
                archivedDropdownRef.current &&
                !archivedDropdownRef.current.contains(event.target)
            ) {
                setArchivedParentBrandDropdownOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [archivedParentBrandDropdownOpen]);



    useEffect(() => {
        console.log('location.state on mount:', location.state);

        if (location && location.state && location.state.success) {
            setSuccessMessage(location.state.success);
            history.replace(location.pathname, {});

            const t = setTimeout(() => setSuccessMessage(''), 5000);
            return () => clearTimeout(t);
        }
    }, [location, history]);


    useEffect(() => {
        if (successMessage) {
            const t = setTimeout(() => setSuccessMessage(""), 5000);
            return () => clearTimeout(t);
        }
    }, [successMessage]);
    useEffect(() => {
        if (filterPopupOpen && filterButtonRef.current) {
            const rect = filterButtonRef.current.getBoundingClientRect();
            setFilterPosition({
                top: rect.bottom + window.scrollY,
                left: rect.left + window.scrollX
            });
        }
    }, [filterPopupOpen]);


    const handleCloseFilterPopup = () => {
        setSelectedStatuses([]);
        setSelectedParentBrands([]);
        setTempParentBrands([]);
        setTempStatuses([]);
        setParentBrandDropdownOpen(false);
        setParentSearchTerm("");
        setFilterPopupOpen(false);
    };

    useEffect(() => {
        function handleClickOutside(event) {
            if (
                filterPopupRef.current &&
                !filterPopupRef.current.contains(event.target) &&
                filterButtonRef.current &&
                !filterButtonRef.current.contains(event.target)
            ) {
                console.log("🟡 Clicked outside filter popup");
                handleCloseFilterPopup();
            }
        }

        if (filterPopupOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [filterPopupOpen]);


    useEffect(() => {
        const handleClickOutside = (e) => {
            if (isParentBrandOpen && parentBrandRef.current && !parentBrandRef.current.contains(e.target)) {
                setIsParentBrandOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isParentBrandOpen]);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (toolbarRef.current && !toolbarRef.current.contains(e.target)) {
                setToolbarDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        function handleClickOutside(event) {
            if (archivedRef.current && !archivedRef.current.contains(event.target)) {
                setArchivedModalOpen(false);
            }
        }
        if (archivedModalOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [archivedModalOpen]);

    // ── Prefetch helpers ──────────────────────────────────────────────────────
    function buildBrandCacheKey(page, search, statuses, parentBrands, sf, so, isArchived) {
        return JSON.stringify({ page, search: search.trim(), statuses, parentBrands, sf, so, isArchived });
    }

    function brandOrderingParam(sf, so) {
        if (!sf) return '-modified_at';
        const prefix = so === 'desc' ? '-' : '';
        return `${prefix}${sf}`;
    }

    async function prefetchBrandPage(page, search, statuses, parentBrands, sf, so, isArchived, count, cacheRef, inProgressRef) {
        const totalPages = Math.ceil(count / PAGE_SIZE);
        if (page > totalPages) return;
        const key = buildBrandCacheKey(page, search, statuses, parentBrands, sf, so, isArchived);
        if (cacheRef.current.has(key) || inProgressRef.current.has(key)) return;
        inProgressRef.current.add(key);
        try {
            const params = new URLSearchParams({ is_archived: isArchived ? 'true' : 'false', page, page_size: PAGE_SIZE });
            if (search.trim()) params.set('search', search.trim());
            if (statuses.length) params.set('status_filter', statuses.join(','));
            if (parentBrands.length) params.set('parent_brand', parentBrands.join(','));
            params.set('ordering', brandOrderingParam(sf, so));
            const res = await apiHelper(`inventory/brands/?${params}`, 'GET');
            if (res.ok) {
                const json = await res.json();
                const mapped = (json.results || []).map(item => ({
                    ...item,
                    status_name: item.status == 1 ? 'Active' : 'Inactive',
                    parent_brand_name: item.parent_name || '',
                }));
                cacheRef.current.set(key, { results: mapped, count: json.count || 0 });
            }
        } catch (_) { /* silent */ } finally { inProgressRef.current.delete(key); }
    }
    // ── End prefetch helpers ──────────────────────────────────────────────────

    // Debounce active search
    useEffect(() => {
        if (isFirstBrandSearchRender.current) {
            isFirstBrandSearchRender.current = false;
            setDebouncedBrandSearch(searchTerm);
            return;
        }
        const t = setTimeout(() => { setCurrentPage(1); setDebouncedBrandSearch(searchTerm); }, 300);
        return () => clearTimeout(t);
    }, [searchTerm]);

    // Debounce archived search
    useEffect(() => {
        if (isFirstArchivedBrandSearchRender.current) {
            isFirstArchivedBrandSearchRender.current = false;
            setDebouncedArchivedBrandSearch(archivedSearchTerm);
            return;
        }
        const t = setTimeout(() => { setArchivedCurrentPage(1); setDebouncedArchivedBrandSearch(archivedSearchTerm); }, 300);
        return () => clearTimeout(t);
    }, [archivedSearchTerm]);

    // Reset active page when filters/sort change
    useEffect(() => {
        if (isFirstBrandFilterRender.current) { isFirstBrandFilterRender.current = false; return; }
        setCurrentPage(1);
        prefetchCache.current.clear();
        prefetchInProgress.current.clear();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedStatuses, selectedParentBrands, sortField, sortOrder]);

    // Reset archived page when archived filters/sort change
    useEffect(() => {
        if (isFirstArchivedBrandFilterRender.current) { isFirstArchivedBrandFilterRender.current = false; return; }
        setArchivedCurrentPage(1);
        archivedPrefetchCache.current.clear();
        archivedPrefetchInProgress.current.clear();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [archivedSearchParentBrand, sortField, sortOrder]);

    // Server-side fetch — active brands
    useEffect(() => {
        async function loadBrands() {
            const key = buildBrandCacheKey(currentPage, debouncedBrandSearch, selectedStatuses, selectedParentBrands, sortField, sortOrder, false);
            const cached = prefetchCache.current.get(key);
            if (cached) {
                setBrandsData(cached.results);
                setTotalCount(cached.count);
                setIsLoading(false);
                prefetchBrandPage(currentPage + 1, debouncedBrandSearch, selectedStatuses, selectedParentBrands, sortField, sortOrder, false, cached.count, prefetchCache, prefetchInProgress);
                return;
            }
            const isInitial = isFirstBrandLoad.current;
            if (isInitial) { showLoader(); isFirstBrandLoad.current = false; }
            setIsLoading(true);
            try {
                const params = new URLSearchParams({ is_archived: 'false', page: currentPage, page_size: PAGE_SIZE });
                if (debouncedBrandSearch.trim()) params.set('search', debouncedBrandSearch.trim());
                if (selectedStatuses.length) params.set('status_filter', selectedStatuses.join(','));
                if (selectedParentBrands.length) params.set('parent_brand', selectedParentBrands.join(','));
                params.set('ordering', brandOrderingParam(sortField, sortOrder));
                const res = await apiHelper(`inventory/brands/?${params}`, 'GET');
                if (res.ok) {
                    const json = await res.json();
                    const mapped = (json.results || []).map(item => ({
                        ...item,
                        status_name: item.status == 1 ? 'Active' : 'Inactive',
                        parent_brand_name: item.parent_name || '',
                    }));
                    setBrandsData(mapped);
                    setTotalCount(json.count || 0);
                    prefetchBrandPage(currentPage + 1, debouncedBrandSearch, selectedStatuses, selectedParentBrands, sortField, sortOrder, false, json.count || 0, prefetchCache, prefetchInProgress);
                } else {
                    console.error('Failed to fetch brands');
                }
            } catch (e) {
                console.error('Failed to fetch brands:', e);
            } finally {
                setIsLoading(false);
                if (isInitial) hideLoader();
            }
        }
        loadBrands();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage, debouncedBrandSearch, selectedStatuses, selectedParentBrands, sortField, sortOrder]);

    // Server-side fetch — archived brands
    useEffect(() => {
        async function loadArchivedBrands() {
            const key = buildBrandCacheKey(archivedCurrentPage, debouncedArchivedBrandSearch, [], archivedSearchParentBrand, sortField, sortOrder, true);
            const cached = archivedPrefetchCache.current.get(key);
            if (cached) {
                setArchivedBrands(cached.results);
                setArchivedTotalCount(cached.count);
                prefetchBrandPage(archivedCurrentPage + 1, debouncedArchivedBrandSearch, [], archivedSearchParentBrand, sortField, sortOrder, true, cached.count, archivedPrefetchCache, archivedPrefetchInProgress);
                return;
            }
            try {
                const params = new URLSearchParams({ is_archived: 'true', page: archivedCurrentPage, page_size: PAGE_SIZE });
                if (debouncedArchivedBrandSearch.trim()) params.set('search', debouncedArchivedBrandSearch.trim());
                if (archivedSearchParentBrand.length) params.set('parent_brand', archivedSearchParentBrand.join(','));
                params.set('ordering', brandOrderingParam(sortField, sortOrder));
                const res = await apiHelper(`inventory/brands/?${params}`, 'GET');
                if (res.ok) {
                    const json = await res.json();
                    const mapped = (json.results || []).map(item => ({
                        ...item,
                        status_name: item.status == 1 ? 'Active' : 'Inactive',
                        parent_brand_name: item.parent_name || '',
                    }));
                    setArchivedBrands(mapped);
                    setArchivedTotalCount(json.count || 0);
                    prefetchBrandPage(archivedCurrentPage + 1, debouncedArchivedBrandSearch, [], archivedSearchParentBrand, sortField, sortOrder, true, json.count || 0, archivedPrefetchCache, archivedPrefetchInProgress);
                }
            } catch (e) {
                console.error('Failed to fetch archived brands:', e);
            }
        }
        loadArchivedBrands();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [archivedCurrentPage, debouncedArchivedBrandSearch, archivedSearchParentBrand, sortField, sortOrder]);

    // Server handles filtering/sorting — brandsData already contains the current page
    const filtered = brandsData;


    const handleCheckboxChange = (setter, value) => (e) => {
        const isChecked = e.target.checked;
        setter(prev =>
            isChecked
                ? [...prev, value]
                : prev.filter(v => v !== value)
        );
    };
    useEffect(() => {
        if (filterPopupOpen && filterButtonRef.current) {
            const rect = filterButtonRef.current.getBoundingClientRect();
            setFilterPosition({
                top: rect.bottom + window.scrollY,
                left: rect.left + window.scrollX
            });
        }
    }, [filterPopupOpen]);

    useEffect(() => {
        if (archivedFilterPopupOpen && archivedFilterButtonRef.current) {
            const rect = archivedFilterButtonRef.current.getBoundingClientRect();
            setArchivedFilterPosition({
                top: rect.bottom + window.scrollY,
                left: rect.left + window.scrollX
            });
        }
    }, [archivedFilterPopupOpen]);


    // Server handles filtering/sorting — archivedBrands already contains the current page
    const archivedFiltered = archivedBrands;

    const totalPages = Math.ceil(totalCount / PAGE_SIZE);
    const pageData = brandsData;
    const archivedTotalPages = Math.ceil(archivedTotalCount / PAGE_SIZE);
    const archivedPageData = archivedBrands;

    console.log('this is data', archivedPageData);
    const toggleSelect = id => {
        setSelectedIds(ids => {
            const newIds = ids.includes(id)
                ? ids.filter(x => x !== id)
                : [...ids, id];
            setSuppressHighlight(false);
            return newIds;
        });
    };

    const toggleAll = () => {
        setSelectedIds(prev => {
            const next =
                prev.length === pageData.length
                    ? []
                    : pageData.map(d => d.brand_id);
            setSuppressHighlight(false);
            return next;
        });
    };

    const onRowClick = (row) => {
        setBrandStack([row])
        setSelectedRow(row);
        setDrawerTab('general');
        setDrawerOpen(true);
    };

    const handleParentBrandClick = (parentBrandId) => {
        if (!parentBrandId) return;

        const parentBrand = brandsData.find(
            (b) => b.brand_id === parentBrandId
        );
        if (!parentBrand) return;

        setBrandStack((prev) => [...prev, parentBrand]);
        setSelectedRow(parentBrand);
        setDrawerTab("general");
        setDrawerOpen(true);
    };


    const handleBackToPreviousBrand = () => {
        setBrandStack((prev) => {
            if (prev.length <= 1) return prev;

            const newStack = prev.slice(0, -1);
            setSelectedRow(newStack[newStack.length - 1]);
            return newStack;
        });
    };



    useEffect(() => {
        function handleClickOutsideDrawer(event) {
            if (
                drawerOpen &&
                drawerRef.current &&
                !drawerRef.current.contains(event.target) &&
                !archivedModalOpen &&
                !deactivateModalOpen &&
                !spuLinkedModalOpen


            ) {
                setDrawerOpen(false);
                setSelectedRow(null);
                setSelectedIds(ids =>
                    selectedRow ? ids.filter(id => id !== selectedRow.external_id) : ids
                );
                setPreviousBrand(null);
            }
        }
        document.addEventListener('mousedown', handleClickOutsideDrawer);
        return () =>
            document.removeEventListener('mousedown', handleClickOutsideDrawer);
    }, [drawerOpen, selectedRow, archivedModalOpen, deactivateModalOpen, spuLinkedModalOpen]);

    // Toggle the per‐row dropdown menu
    const toggleDropdown = (id) => {
        if (dropdownOpenId === id) {
            setDropdownOpenId(null);
        } else {
            const btn = buttonRefs.current[id];
            if (btn) {
                const rect = btn.getBoundingClientRect();
                const dropdownWidth = 150;
                const dropdownHeight = 100;
                let left = rect.left + window.scrollX - dropdownWidth + rect.width;
                if (left < window.scrollX + 8) {
                    left = window.scrollX + 8;
                }
                let top = rect.bottom + window.scrollY;
                if (top + dropdownHeight > window.scrollY + window.innerHeight) {
                    top = rect.top + window.scrollY - dropdownHeight;
                }
                setDropdownPosition({ top, left });
            }
            setDropdownOpenId(id);
        }
    };
    useEffect(() => {
        console.log("BRAND STACK:", brandStack.map(b => b?.brand_name));
    }, [brandStack]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownOpenId(null);
            }
        }

        if (dropdownOpenId !== null) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [dropdownOpenId]);


    useEffect(() => {
        const handleClickOutside = (e) => {
            if (isParentBrandOpen && parentBrandRef.current && !parentBrandRef.current.contains(e.target)) {
                setIsParentBrandOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isParentBrandOpen]);



    const openArchiveModal = (brandId) => {
        setSelectedBrandId(brandId);
        setArchivedModalOpen(true);

    };

    const handleArchivedConfirm = async (brandId) => {
        if (!brandId) return;

        try {
            const response = await apiHelper(`inventory/brands/${brandId}/archive/`, 'POST');
            if (response.ok) {
                const data = await response.json();
                setSuccessMessage(data.detail || 'Brand Archived Successfully');

                // Get the brand name before removing it
                const archivedBrandName = brandsData.find(brand => brand.brand_id === brandId)?.brand_name;

                // 1. Remove the archived brand
                setBrandsData(prev => prev.filter(brand => brand.brand_id !== brandId));

                // 2. Update all child brands to remove the archived parent reference
                setBrandsData(prev => prev.map(brand => {
                    if (brand.parent_name === archivedBrandName) {
                        return {
                            ...brand,
                            parent_name: null,
                            parent_brand: null,
                            parent_brand_name: null
                        };
                    }
                    return brand;
                }));

                // 3. Also update archived brands if any child was already archived
                setArchivedBrands(prev => prev.map(brand => {
                    if (brand.parent_name === archivedBrandName) {
                        return {
                            ...brand,
                            parent_name: null,
                            parent_brand: null,
                            parent_brand_name: null
                        };
                    }
                    return brand;
                }));

                // 4. Update the selected row if it's a child of the archived brand
                if (selectedRow && selectedRow.parent_name === archivedBrandName) {
                    setSelectedRow(prev => ({
                        ...prev,
                        parent_name: null,
                        parent_brand: null,
                        parent_brand_name: null
                    }));
                }

                // 5. Update pageData (filtered brands) to reflect changes
                // This will happen automatically when brandsData updates and filtered recomputes

                // Clear caches so both tabs reload fresh data
                prefetchCache.current.clear();
                prefetchInProgress.current.clear();
                archivedPrefetchCache.current.clear();
                archivedPrefetchInProgress.current.clear();
                setTotalCount(prev => Math.max(0, prev - 1));
                setArchivedCurrentPage(1); // triggers archived fetch useEffect
                setDrawerOpen(false);
            } else if (response.status === 400) {
                const response_errors = await response.json();

                if (response_errors.detail === "Cannot archive this brand. SPUs are linked to it.") {
                    setSpuLinkedModalOpen(true);
                    setLinkedModalMessage("This brand can't be archived because it's referenced by one or more SPUs. Please remove or reassign those SPUs before archiving.");
                } else if (response_errors.detail === "Cannot archive this brand. other brands are linked to it.") {
                    setSpuLinkedModalOpen(true);
                    setLinkedModalMessage(response_errors.detail);
                } else {
                    let errors = [];
                    for (let i in response_errors) {
                        errors.push(`${i}: ${response_errors[i][0]}`);
                    }
                    setValidationError(errors);
                    setSuccessMessage('');
                }
            }
        } catch (error) {
            console.error("Error archiving brand:", error);
            setSuccessMessage('');
        }
        setArchivedModalOpen(false);
    };

    // fetchArchivedBrands removed — archived brands are now loaded by the
    // server-side paginated useEffect above.

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                parentBrandDropdownOpen &&
                parentDropdownRef.current &&
                !parentDropdownRef.current.contains(event.target)
            ) {
                setParentBrandDropdownOpen(false);
            }
        };

        // use capture phase so that clicks inside don't trigger premature close
        document.addEventListener("mousedown", handleClickOutside, true);
        return () => document.removeEventListener("mousedown", handleClickOutside, true);
    }, [parentBrandDropdownOpen]);

    const handleDeactivateBrand = async (brandId) => {
        console.log('Deactivating brand ID:', brandId);
        if (!brandId) return;
        console.log('Deactivating brand ID:', brandId);
        try {
            const response = await apiHelper(`inventory/brands/${brandId}/deactivate/`, 'POST');
            if (response.ok) {
                const data = await response.json();
                const isActive = data.status;
                const newStatusText = isActive ? "Active" : "Inactive";
                setSuccessMessage(data.detail || 'Status updated successfully.');
                setBrandsData(prev =>
                    prev.map(brand =>
                        brand.brand_id === brandId
                            ? { ...brand, status: isActive, status_text: newStatusText }
                            : brand
                    )
                );
                // ✅ also update selectedRow if it's the same branch
                setSelectedRow(prev =>
                    prev && prev.brand_id === brandId
                        ? { ...prev, status: isActive, status_text: newStatusText }
                        : prev
                );
                setDropdownOpenId(null);
                setDeactivateModalOpen(false);
            } else {
                const error = await response.json();
                console.error("Error toggling brand status:", error);
                setDeactivateModalOpen(false);
            }
        } catch (err) {
            console.error("Network/server error while toggling brand status:", err);
        }
    };
    // 🧩 Handle button click
    const handleActionClick = async (brandId) => {
        console.log('Toggling status for brand ID:', brandId, 'Current status:', currentRow.status_text);
        if (currentRow.status_text === "Active") {
            // Only show confirmation for deactivation
            setDeactivateModalOpen(true);
            setSelectedBrandId(brandId);
        } else {
            handleDeactivateBrand(brandId);
            console.log('Brand activated without confirmation for brand ID:', brandId);
        }
    };

    const handleArchivedCheckboxChange = (setter, value) => (e) => {
        const isChecked = e.target.checked;
        setter(prev =>
            isChecked
                ? [...prev, value]
                : prev.filter(v => v !== value)
        );
    };



    useEffect(() => {
        function handleClickOutside(event) {
            if (archivedRef.current && !archivedRef.current.contains(event.target)) {
                setArchivedModalOpen(false);
            }
        }

        if (archivedModalOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [archivedModalOpen]);


    useEffect(() => {


        async function fetchInitialData() {
            try {
                // Now fetch employees
                const brandsRes = await apiHelper('inventory/brands/?is_archived=false', 'GET');
                if (brandsRes.ok) {
                    const result = await brandsRes.json();
                    let sampleData = result;
                    sampleData = sampleData.map(item => {
                        const parentBrand = sampleData.find(m => m.brand_id == item.parent_brand?.toString());

                        return {
                            ...item,
                            status_name: item.status == 1 ? 'Active' : 'Inactive',
                            parent_brand_name: parentBrand ? parentBrand.brand_name : '',
                        };
                    });
                    setAllBrandsForFilter(sampleData);
                }

            } catch (error) {
                console.error('Failed to fetch initial data:', error);
            }
        }

        fetchInitialData();
    }, []);


    const editBrand = () => {
        if (selectedIds.length === 1) {
            history.push(`/brand/edit-brand/${selectedIds[0]}`);
        } else if (dropdownOpenId) {
            history.push(`/brand/edit-brand/${dropdownOpenId}`);
        } else if (selectedRow?.brand_id) {
            history.push(`/brand/edit-brand/${selectedRow.brand_id}`);
        }
    };


    // Drawer Dropdown latest code below

    const toggleToolbarDropdown = () => {
        setToolbarDropdownOpen(prev => !prev);
    };
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (toolbarRef.current && !toolbarRef.current.contains(e.target)) {
                setToolbarDropdownOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleCopy = async (textToCopy) => {
        if (!textToCopy) {
            console.error('No text to copy');
            alert('Failed to copy: No text available.');
            return;
        }

        // Use Clipboard API if available and secure
        if (window.isSecureContext && navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
            try {
                await navigator.clipboard.writeText(textToCopy);
                setCopied(true);
                setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
            } catch (err) {
                console.error('Clipboard API failed:', err);
                fallbackCopyTextToClipboard(textToCopy);
            }
        } else {
            console.warn('Clipboard API not available or not in secure context, using fallback');
            fallbackCopyTextToClipboard(textToCopy);
        }
    };

    const fallbackCopyTextToClipboard = (text) => {
        try {
            const textArea = document.createElement('textarea');
            textArea.value = text;
            textArea.style.position = 'fixed';
            textArea.style.top = '0';
            textArea.style.left = '0';
            textArea.style.opacity = '0';
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            const successful = document.execCommand('copy');
            document.body.removeChild(textArea);

            if (successful) {
                setCopied(true);
                setTimeout(() => setCopied(false), 2000);
            } else {
                console.error('Fallback copy failed');
                alert('Failed to copy text. Please copy manually.');
            }
        } catch (err) {
            console.error('Fallback copy error:', err);
            alert('Failed to copy text. Please copy manually.');
        }
    };

    const handleSaveConfirm = () => {
        setSaveModalOpen(false);
    };

    useEffect(() => {
        function handleClickOutside(event) {
            if (saveRef.current && !saveRef.current.contains(event.target)) {
                setSaveModalOpen(false);
            }
        }

        if (saveModalOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [saveModalOpen]);

    const handleSort = (field) => {
        if (sortField === field) {
            // toggle order
            setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
        } else {
            setSortField(field);
            setSortOrder('asc');
        }
    };
    const handleRowClick = (row) => {
        console.log("Row clicked:", row);
        setSelectedRow(row); // if you already have setSelectedRow in state
        // any other action you need
    };

    const [autoOpen, setAutoOpen] = useState(false);
    const [brandId, setBrandId] = useState(null);
    const [hasAutoOpened, setHasAutoOpened] = useState(false);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const idFromQuery = params.get("id");

        if (idFromQuery) {
            setBrandId(Number(idFromQuery));
            setAutoOpen(true);
        }
    }, []);
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const idFromQuery = params.get('id');
        const autoOpen = params.get('autoOpen') === 'true';
        const tab = params.get('tab');

        if (idFromQuery && autoOpen && !hasAutoOpened) {
            const row = brandsData.find((d) => d.brand_id === Number(idFromQuery));
            if (row) {
                setSelectedRow(row);
                setDrawerOpen(true);
                setDrawerTab(tab || 'general'); // Use tab from query or default to 'general'
                setHasAutoOpened(true);
            }
        }
    }, [location.search, brandsData, hasAutoOpened]);
    useEffect(() => {
        if (autoOpen && brandId && pageData.length > 0 && !hasAutoOpened) {
            const row = pageData.find((d) => d.brand_id === Number(brandId));
            if (row) {
                onRowClick(row); // open the brand drawer
                setHasAutoOpened(true);
            }
        }
    }, [autoOpen, brandId, pageData, hasAutoOpened, onRowClick]);


    const handleCloseArchivedFilterPopup = () => {
        setArchivedSearchParentBrand([]);
        setTempArchivedParentBrands([]);
        setArchivedParentBrandDropdownOpen(false);
        setArchivedParentBrandSearchTerm("");

        // 🧹 Finally close the popup
        setArchivedFilterPopupOpen(false);
    };

    useEffect(() => {
        function handleClickOutside(event) {
            if (
                archivedFilterPopupRef.current &&
                !archivedFilterPopupRef.current.contains(event.target) &&
                archivedFilterButtonRef.current &&
                !archivedFilterButtonRef.current.contains(event.target)
            ) {
                console.log('sdjbsjhdshjdhsjbdjhsdhjs')
                handleCloseArchivedFilterPopup();
            }
        }

        if (archivedFilterPopupOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [archivedFilterPopupOpen]);

    const FilterActiveIcon = () => (
        <svg style={{ margin: 0 }} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.6325 6.44444C20.7252 6.24267 20.7746 6.02858 20.8107 5.74756C21.0354 4.00089 21.1478 3.12756 21.6356 2.56378C20.1234 2 19.2177 2 17.4063 2H4.59369C2.78227 2 1.87655 2 1.36439 2.56378C0.852232 3.12756 0.964572 4.00089 1.18925 5.74756C1.25487 6.25766 1.36399 6.54725 1.69704 6.94296C2.77293 8.22128 4.74334 10.4951 7.50829 12.5623C7.76095 12.7512 7.92676 13.0599 7.95475 13.4016C8.26623 17.2071 8.55159 19.8068 8.70309 21.0865C8.78256 21.7577 9.52673 22.274 10.14 21.8404C11.1702 21.1118 13.0947 20.2952 13.349 18.938C13.4692 18.2964 13.6451 17.1765 13.8437 15.3333" stroke="#0D6EFD" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <g clipPath="url(#clip0_4516_4830)">
                <path d="M22.8125 11C22.8125 14.2102 20.2102 16.8125 17 16.8125C13.7898 16.8125 11.1875 14.2102 11.1875 11C11.1875 7.78987 13.7898 5.18753 17 5.18753C20.2102 5.18753 22.8125 7.78987 22.8125 11ZM16.3277 14.0777L20.6402 9.7652C20.7866 9.61877 20.7866 9.38132 20.6402 9.23488L20.1099 8.70456C19.9634 9.5581 19.726 9.5581 19.5795 8.70456L16.0625 12.2215L14.4205 10.5795C14.2741 10.4331 14.0366 10.4331 13.8901 10.5795L13.3598 11.1099C13.2134 11.2563 13.2134 11.4937 13.3598 11.6402L15.7973 14.0777C15.9438 14.2241 16.1812 14.2241 16.3277 14.0777Z" fill="#0D6EFD" />
            </g>
            <defs>
                <clipPath id="clip0_4516_4830">
                    <rect width="12" height="12" fill="white" transform="translate(11 5)" />
                </clipPath>
            </defs>
        </svg>
    );

    const FilterInactiveIcon = () => (
        <svg style={{ margin: 0 }} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M21.6323 6.44444C21.7251 6.24267 21.7744 6.02858 21.8106 5.74756C22.0353 4.00089 22.1476 3.12756 21.6354 2.56378C21.1233 2 20.2176 2 18.4062 2H5.59366C3.78225 2 2.87655 2 2.36439 2.56378C1.85223 3.12756 1.96457 4.00089 2.18925 5.74756C2.25487 6.25766 2.36399 6.54725 2.69703 6.94296C3.77291 8.22128 5.74331 10.4951 8.50823 12.5623C8.76089 12.7512 8.9267 13.0599 8.95469 13.4016C9.26616 17.2071 9.55152 19.8068 9.70302 21.0865C9.78249 21.7577 10.5267 22.274 11.1399 21.8404C12.1701 21.1118 14.0946 20.2952 14.3489 18.938C14.4691 18.2964 14.645 17.1765 14.8436 15.3333" stroke="#6C757D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M18.1113 7.5556V15.3334M22.0001 11.4445L14.2224 11.4445" stroke="#6C757D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );

    const FilterDisabledIcon = () => (
        <svg style={{ margin: 0 }} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M21.6323 6.44444C21.7251 6.24267 21.7744 6.02858 21.8106 5.74756C22.0353 4.00089 22.1476 3.12756 21.6354 2.56378C21.1233 2 20.2176 2 18.4062 2H5.59366C3.78225 2 2.87655 2 2.36439 2.56378C1.85223 3.12756 1.96457 4.00089 2.18925 5.74756C2.25487 6.25766 2.36399 6.54725 2.69703 6.94296C3.77291 8.22128 5.74331 10.4951 8.50823 12.5623C8.76089 12.7512 8.9267 13.0599 8.95469 13.4016C9.26616 17.2071 9.55152 19.8068 9.70302 21.0865C9.78249 21.7577 10.5267 22.274 11.1399 21.8404C12.1701 21.1118 14.0946 20.2952 14.3489 18.938C14.4691 18.2964 14.645 17.1765 14.8436 15.3333" stroke="#CED4DA" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M18.1113 7.5556V15.3334M22.0001 11.4445L14.2224 11.4445" stroke="#CED4DA" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );

    const filtersApplied = selectedStatuses.length > 0 || selectedParentBrands.length > 0;
    const archivedFiltersApplied = archivedSearchParentBrand.length > 0;



    // Helper: Get all unique parent chains
    function getAllParentChains(brandsData) {
        const allParents = new Set();
        const brandMap = {};

        // Build brand → parent map (NA if missing)
        brandsData.forEach((b) => {
            if (b.brand_name) brandMap[b.brand_name] = b.parent_name || 'NA';
        });

        // Helper: recursively find ancestors
        const findAncestors = (brand) => {
            const seen = new Set();
            let current = brandMap[brand];

            while (current && !seen.has(current)) {
                seen.add(current);
                allParents.add(current);

                // If parent isn't in the map (i.e., not in data), mark as NA and stop
                if (!brandMap[current]) {
                    allParents.add('NA');
                    break;
                }

                current = brandMap[current];
            }
        };

        // Build ancestor chains for all brands
        Object.keys(brandMap).forEach(findAncestors);

        // Always include NA
        allParents.add('NA');

        console.log("All parent chains:", Array.from(allParents));
        return Array.from(allParents);
    }


    const highlightMatch = (text, searchTerm) => {
        if (!searchTerm) return text;
        const regex = new RegExp(`(${searchTerm})`, "gi");
        return text.replace(
            regex,
            '<span>$1</span>'
        );
    };

    const isBrandNameOverflowing = (brandName) => {
        if (!brandName) return false;
        // Consider category name lengthy if it's more than 30 characters
        return brandName.length > 30;
    };

    const columns = [
        {
            label: "Brand Name",
            field: "brand_name",
            sortable: true,
            width: '15%',
            render: (row) => (
                <div style={{ display: "flex", alignItems: "center" }}>
                    <img
                        src={row.original_logo_url || noImage}
                        alt="logo"
                        style={{ width: 32, height: 32, marginRight: 8, flexShrink: 0 }}
                        onError={(e) => (e.target.src = noImage)}
                    />
                    <span
                        style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            display: "block",
                        }}
                    >
                        {row.brand_name}
                    </span>
                </div>
            ),
        },
        { label: "ID", field: "external_id", width: '13%', sortable: true },
        { label: "Status", field: "status_text", width: '121px', fixed: true, sortable: true },
        {
            label: "Parent Brand",
            field: "parent_name",
            sortable: true,
            width: '18%',
            render: (row) =>
                row.parent_name ? (
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <img
                            src={
                                pageData.find((d) => d.brand_id === row.parent_brand)
                                    ?.original_logo_url || noImage
                            }
                            alt="parent"
                            style={{ width: 32, height: 32, marginRight: 6, flexShrink: 0 }}
                            onError={(e) => (e.target.src = noImage)}
                        />
                        <span
                            style={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                display: "block",
                            }}
                        >
                            {row.parent_name}
                        </span>
                    </div>
                ) : (
                    <span style={{ color: "#ADB5BD" }}>NA</span>
                ),
        },
        { label: "Prefix", field: "prefix", sortable: true, width: '15%', },
        { label: "Last Modified Time", field: "modified_at", width: '18%', sortable: true, render: (row) => formatDateTime(row.modified_at), },
    ];
    const isinitialTableEmpty = pageData.length === 0;



    const isSearching = searchTerm?.trim().length > 0;
    const isFilterApplied = selectedStatuses.length > 0 || selectedParentBrands.length > 0;
    const isTableEmpty = isinitialTableEmpty && !isSearching && !isFilterApplied;


    const emptyImage = (isSearching || isFilterApplied) ? emptySearchImg : noBrandImage;

    const emptyTitle =
        (isSearching || isFilterApplied)
            ? "No Brand Found"
            : "No Brand Exist";

    const emptyMessage =
        isSearching
            ? "No results match what you’re looking for"
            : isFilterApplied
                ? "No results match your filters"
                : "Nothing here yet. Add your first item to get started!";


    const archivedColumns = [
        {
            label: "Brand Name",
            field: "brand_name",
            sortable: true,
            render: (row) => (
                <div style={{ display: "flex", alignItems: "center" }}>
                    <img
                        src={row.original_logo_url || noImage}
                        onError={(e) => { e.target.src = noImage }}
                        style={{ width: 32, height: 32, marginRight: 8 }}
                    />
                    <span style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap"
                    }}>
                        {row.brand_name}
                    </span>
                </div>
            ),
        },

        { label: "ID", field: "external_id", width: '121px', fixed: true, sortable: true },
        { label: "Parent Brand", field: "parent_name", sortable: true },
        { label: "Prefix", field: "prefix", sortable: true },
        {
            label: "Archived Time",
            field: "archived_at",
            sortable: true,
            render: (row) => formatDateTime(row.archived_at),
        }

    ];

    const isArchivedSearching = archivedSearchTerm?.trim().length > 0;

    const isArchivedFilterApplied =
        archivedSearchParentBrand.length > 0;



    const isArchivedEmptyState =
        archivedPageData.length === 0 &&
        !isArchivedSearching &&
        !isArchivedFilterApplied;

    const archiveEmptyImage = (isArchivedSearching || isArchivedFilterApplied) ? emptySearchImg : noBrandImage;

    const emptyArchivedTitle = isArchivedSearching || isFilterApplied
        ? "No Archived Brand Found"
        : "No Archived Brand Exist";

    const emptyArchivedMessage = isArchivedSearching
        ? "No results match what you’re looking for"
        : isArchivedFilterApplied
            ? "No results match what you’re looking for"
            : "Nothing here yet. Add your first item to get started!";


    const openBrand = (brand) => {
        setBrandStack(prev => [...prev, brand]);
        setSelectedRow(brand);
        setDrawerOpen(true);
    };

    return (
        <div className="company-body new-look">
            <div className="breadcrumb">
                {breadcrumbs.map((crumb, index) => (
                    <span key={index} className="breadcrumb-item">
                        {crumb}
                        {index !== breadcrumbs.length - 1}
                    </span>
                ))}
                {/* Add brand name to breadcrumb when drawer is open */}
                {/* <>
                    <span className="breadcrumb-separator px-2"> / </span>
                    <span className="breadcrumb-item active">
                        {activeTab == 'archived-brands' ? 'Archived Brands' : 'Brands'}
                    </span>
                </> */}
            </div>

            {successMessage && (
                <AlertNotification
                    type="success"
                    recordName="Brand"
                    action={
                        successMessage.includes("Archived")
                            ? "archive"
                            : successMessage.includes("Discarded")
                                ? "discard"
                                : successMessage.includes("Activated")
                                    ? "activate"
                                    : successMessage.includes("Deactivated")
                                        ? "deactivate"
                                        : "create"
                    }
                    onClose={() => setSuccessMessage("")}
                />
            )}

            <div className="employee-tabs-container">
                <div className="tabs">
                    <button
                        className={`tab ${activeTab === 'brands' ? 'active' : ''}`}
                        onClick={() => setActiveTab('brands')}
                    >
                        Brands
                    </button>
                    <button
                        className={`tab ${activeTab === 'archived-brands' ? 'active' : ''}`}
                        onClick={() => setActiveTab('archived-brands')}
                    >
                        Archived Brands
                    </button>
                </div>

                {activeTab === 'brands' && (
                    <div className="tab-content" id="brands-content">
                        <div className="info-section">
                            <div className="info-card">
                                <div className="entities-tab">
                                    <div className="toolbar">
                                        <div className="toolbar-left">
                                            <SearchBox
                                                searchInput={searchInput}
                                                setSearchInput={setSearchInput}
                                                setSearchTerm={setSearchTerm}
                                                setCurrentPage={setCurrentPage}
                                                disabled={isTableEmpty}
                                            />

                                            <button
                                                ref={filterButtonRef}
                                                className={`icon-btn p-2 filter-btn ${filtersApplied ? 'applied' : ''}`}
                                                onClick={() => !isTableEmpty && setFilterPopupOpen(!filterPopupOpen)}   // ← Block clicks
                                                disabled={isTableEmpty}                 // ← NEW

                                                style={{
                                                    border: isTableEmpty
                                                        ? '1px solid var(--Gray-400, #CED4DA)'
                                                        : filtersApplied
                                                            ? '1px solid #2C7BE5'
                                                            : '1px solid #6C757D',
                                                    borderWidth: '1px',
                                                    color: isTableEmpty ? '#CED4DA' : filtersApplied ? '#2C7BE5' : '#6C757D',
                                                    background: isTableEmpty
                                                        ? 'var(--Gray-100, #F8F9FA)'
                                                        : filtersApplied
                                                            ? '#CFE2FF'
                                                            : '#FFFFFF',

                                                    height: '40px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    cursor: isTableEmpty ? 'not-allowed' : 'pointer',
                                                    pointerEvents: isTableEmpty ? 'none' : 'auto',
                                                }}
                                            >
                                                {isTableEmpty ? <FilterDisabledIcon /> : filtersApplied ? <FilterActiveIcon /> : <FilterInactiveIcon />}

                                            </button>
                                        </div>
                                        <div className="toolbar-right">
                                            <button
                                                className="icon-btn dark-border"
                                                onClick={() => history.push("/brand/add-brand")}
                                            >
                                                <Plus size={18} /> Add Brand
                                            </button>
                                        </div>
                                    </div>
                                    {filterPopupOpen && (
                                        <>
                                            <div
                                                onClick={handleCloseFilterPopup}
                                                style={{
                                                    position: 'fixed',
                                                    top: 0,
                                                    left: 0,
                                                    width: '100vw',
                                                    height: '100vh',
                                                    backgroundColor: 'rgba(0, 0, 0, 0.4)',
                                                    zIndex: 1500,
                                                    padding: '20px'
                                                }}
                                            />

                                            {/* 🪟 Drawer */}
                                            <div
                                                style={{
                                                    position: 'fixed',
                                                    top: 0,
                                                    right: 0,
                                                    width: 400,
                                                    boxSizing: 'border-box',
                                                    height: '100vh',
                                                    backgroundColor: '#fff',
                                                    boxShadow: '-3px 0 12px rgba(0,0,0,0.1)',
                                                    zIndex: 2000,
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    animation: 'slideIn 0.3s ease-out'
                                                }}
                                            >
                                                {/* Header */}
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        height: '60px',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center',
                                                        alignSelf: 'stretch',
                                                        padding: '15px 20px',
                                                        // borderBottom: '1px solid #f1f1f1',
                                                        background: '#F8F9FA'
                                                    }}
                                                >
                                                    <h4 style={{ margin: 0, fontWeight: 600, color: ' #212529', fontFamily: 'Montserrat', fontSize: '14px', fontStyle: 'normal', lineHeight: 'normal' }}>Filter</h4>
                                                    <button
                                                        onClick={handleCloseFilterPopup}
                                                        style={{
                                                            background: 'none',
                                                            border: 'none',
                                                            cursor: 'pointer',
                                                            padding: '4px'
                                                        }}
                                                    >
                                                        <X size={18} />
                                                    </button>
                                                </div>

                                                {/* Body */}
                                                <div
                                                    style={{
                                                        flex: 1,
                                                        overflowY: 'auto',
                                                        padding: '20px',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        gap: '24px'
                                                    }}
                                                >
                                                    {/* Status Filter */}
                                                    <div style={{
                                                        borderBottom: '1px solid #E9ECEF',
                                                        paddingBottom: '20px'
                                                    }}>
                                                        <label
                                                            style={{
                                                                fontWeight: 600,
                                                                marginBottom: '8px',
                                                                color: '#212529',
                                                                fontFamily: 'Montserrat',
                                                                fontSize: '14px',
                                                                fontStyle: 'normal',
                                                                lineHeight: 'normal'
                                                            }}
                                                        >
                                                            Status
                                                        </label>
                                                        <div style={{ display: 'flex', flexDirection: 'column', }}>
                                                            {['Active', 'Inactive'].map((status) => (
                                                                <label
                                                                    key={status}
                                                                    className="form-check"
                                                                    style={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: '8px',
                                                                        cursor: 'pointer',
                                                                        padding: '10px',
                                                                    }}
                                                                >
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={tempStatuses.includes(status)} // ✅ temp state
                                                                        onChange={handleCheckboxChange(setTempStatuses, status)} // ✅ temp handler
                                                                        style={{ position: "absolute", opacity: 0, width: 0, height: 0 }}


                                                                    />
                                                                    <span
                                                                        style={{
                                                                            width: "18px",
                                                                            height: "18px",
                                                                            border: "1.5px solid #212529",
                                                                            borderRadius: "4px",
                                                                            backgroundColor: tempStatuses.includes(status) ? "#FFEB00" : "white",
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            justifyContent: "center",
                                                                            transition: "all 0.2s ease",
                                                                            position: "relative",
                                                                            flexShrink: 0,
                                                                        }}
                                                                    >
                                                                        {tempStatuses.includes(status) && (
                                                                            <svg
                                                                                width="12"
                                                                                height="12"
                                                                                viewBox="0 0 12 12"
                                                                                fill="none"
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                style={{ position: "absolute" }}
                                                                            >
                                                                                <path
                                                                                    d="M2 6L4.5 8.5L10 3"
                                                                                    stroke="#000"
                                                                                    strokeWidth="2"
                                                                                    strokeLinecap="round"
                                                                                    strokeLinejoin="round"
                                                                                />
                                                                            </svg>
                                                                        )}

                                                                    </span>

                                                                    <span style={{
                                                                        fontFamily: "Montserrat",
                                                                        fontSize: "14px",
                                                                        fontStyle: "normal",
                                                                        fontWeight: "400",
                                                                        lineHeight: "18px",
                                                                        color: "#212529"

                                                                    }}>{status}</span>
                                                                </label>
                                                            ))}
                                                        </div>
                                                    </div>

                                                    <div>
                                                        {/* Label */}
                                                        <label
                                                            style={{
                                                                display: "block",
                                                                fontWeight: 600,
                                                                marginBottom: "8px",
                                                                color: ' #212529',
                                                                fontFamily: 'Montserrat',
                                                                fontSize: '14px',
                                                                fontStyle: 'normal',
                                                                lineHeight: 'normal'
                                                            }}
                                                        >
                                                            Parent Brand
                                                        </label>

                                                        {/* Wrapper */}
                                                        <div
                                                            ref={parentDropdownRef}
                                                            style={{
                                                                position: "relative",
                                                            }}
                                                        >
                                                            {/* Search Box + Chips */}
                                                            <div
                                                                className="search-box-filter"
                                                                style={{
                                                                    border: "1px solid #6C757D",
                                                                    borderRadius: "8px",
                                                                    padding: "6px 8px",
                                                                    display: "flex",
                                                                    flexWrap: "wrap",
                                                                    alignItems: "center",
                                                                    gap: "6px",
                                                                    backgroundColor: "#fff",
                                                                    minHeight: "38px",
                                                                    paddingRight: "32px"

                                                                }}
                                                                onClick={() => setParentBrandDropdownOpen(true)}
                                                            >

                                                                {/* Selected Chips */}
                                                                {tempParentBrands.map((parent) => {
                                                                    if (!parent) return null;
                                                                    return (
                                                                        <span
                                                                            key={parent}
                                                                            style={{
                                                                                backgroundColor: "#ffeb00",
                                                                                color: "#212529",
                                                                                borderRadius: "16px",
                                                                                padding: "5px 10px",
                                                                                display: "inline-flex",
                                                                                alignItems: "center",
                                                                                fontSize: "12px",
                                                                                fontWeight: "600",
                                                                                fontFamily: "Montserrat",
                                                                                // paddingRight: "24px"
                                                                            }}
                                                                        >
                                                                            {parent}
                                                                            <button
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    handleCheckboxChange(setTempParentBrands, parent)({
                                                                                        target: { checked: false },
                                                                                    });
                                                                                }}
                                                                                style={{
                                                                                    background: "none",
                                                                                    border: "none",
                                                                                    marginLeft: "6px",
                                                                                    cursor: "pointer",
                                                                                    padding: "0",
                                                                                    display: "flex",
                                                                                    alignItems: "center",
                                                                                }}
                                                                            >
                                                                                <X size={14} strokeWidth={3} />
                                                                            </button>
                                                                        </span>
                                                                    );
                                                                })}

                                                                {/* Search Input */}
                                                                <input
                                                                    type="text"
                                                                    value={parentSearchTerm}
                                                                    onChange={(e) => {
                                                                        setParentSearchTerm(e.target.value);
                                                                        if (!parentBrandDropdownOpen) setParentBrandDropdownOpen(true);
                                                                    }}
                                                                    onFocus={() => setParentBrandDropdownOpen(true)}
                                                                    style={{
                                                                        border: "none",
                                                                        outline: "none",
                                                                        flexGrow: 1,
                                                                        fontSize: "14px",
                                                                        background: "transparent",
                                                                        minWidth: "120px",
                                                                        color: "#212529",
                                                                    }}
                                                                />

                                                                <div
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        setParentBrandDropdownOpen((prev) => !prev);
                                                                    }}
                                                                    style={{
                                                                        position: "absolute", // ✅ changed from fixed
                                                                        right: "10px",
                                                                        top: "50%",
                                                                        transform: "translateY(-50%)", // ✅ centers it vertically
                                                                        cursor: "pointer",
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        padding: "4px",
                                                                        color: "#6C757D",
                                                                    }}
                                                                >
                                                                    <svg
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        width="18"
                                                                        height="18"
                                                                        viewBox="0 0 18 18"
                                                                        fill="none"
                                                                        style={{
                                                                            transform: parentBrandDropdownOpen ? 'rotate(0deg)' : 'rotate(180deg)',
                                                                            transition: 'transform 0.2s ease',
                                                                        }}
                                                                    >
                                                                        <path
                                                                            d="M4.5 11.25L9 6.75L13.5 11.25"
                                                                            stroke="#212529"
                                                                            strokeWidth="2"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                        />
                                                                    </svg>
                                                                </div>

                                                            </div>

                                                            {/* ✅ Dropdown List */}
                                                            {parentBrandDropdownOpen && (
                                                                <div
                                                                    className="filter-options"
                                                                    style={{
                                                                        position: "absolute",
                                                                        top: "calc(100% + 4px)",
                                                                        left: 0,
                                                                        right: 0,
                                                                        border: "1px solid #e9ecef",
                                                                        borderRadius: "8px",
                                                                        maxHeight: "220px",
                                                                        overflowY: "auto",
                                                                        backgroundColor: "#fff",
                                                                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                                                        zIndex: 9999,
                                                                    }}
                                                                    onClick={(e) => e.stopPropagation()} // don't close when clicking inside
                                                                >
                                                                    {(() => {
                                                                        const filteredParents = [...new Set(allBrandsForFilter.map(b => b.brand_name).filter(Boolean))].sort((a, b) => a.localeCompare(b)).filter((parent) => {
                                                                            const term = parentSearchTerm.toLowerCase();
                                                                            if (parent.toLowerCase().includes(term)) return true;
                                                                            const brandObj = allBrandsForFilter.find(b => b.brand_name === parent);
                                                                            const hierarchy = brandObj?.brand_hierarchy || [];
                                                                            return hierarchy.some(h => h.name.toLowerCase().includes(term));
                                                                        });

                                                                        if (filteredParents.length === 0) {
                                                                            return (
                                                                                <div
                                                                                    style={{
                                                                                        padding: "12px",
                                                                                        textAlign: "center",
                                                                                        color: "#6C757D",
                                                                                        fontSize: "14px",
                                                                                        fontFamily: "Montserrat",
                                                                                    }}
                                                                                >
                                                                                    No results found
                                                                                </div>
                                                                            );
                                                                        }

                                                                        return filteredParents.map((parent, index) => {
                                                                            const isSelected = tempParentBrands.includes(parent);
                                                                            const brandObj = allBrandsForFilter.find(b => b.brand_name === parent);
                                                                            const hierarchy = brandObj?.brand_hierarchy || [];
                                                                            const subtitle = hierarchy.length >= 1 ? hierarchy.map(b => b.name).join(' >> ') : null;
                                                                            return (
                                                                                <div
                                                                                    key={index}
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        handleCheckboxChange(setTempParentBrands, parent)({
                                                                                            target: { checked: !isSelected },
                                                                                        });
                                                                                        setParentSearchTerm("");
                                                                                    }}
                                                                                    style={{
                                                                                        display: "flex",
                                                                                        alignItems: "center",
                                                                                        justifyContent: "space-between",
                                                                                        padding: "8px 12px",
                                                                                        cursor: "pointer",
                                                                                        fontSize: "14px",
                                                                                        borderBottom:
                                                                                            index < filteredParents.length - 1
                                                                                                ? "1px solid #f1f1f1"
                                                                                                : "none",
                                                                                        backgroundColor: isSelected ? "#f8f9fa" : "transparent",
                                                                                    }}
                                                                                >
                                                                                    <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minWidth: 0 }}>
                                                                                        <div
                                                                                            style={{ color: "#212529", fontWeight: "400", fontFamily: "Montserrat", fontStyle: 'normal', fontSize: '14px', lineHeight: "18px" }}
                                                                                            dangerouslySetInnerHTML={{
                                                                                                __html: highlightMatch(parent, parentSearchTerm),
                                                                                            }}
                                                                                        />
                                                                                        {subtitle && (
                                                                                            <div style={{ fontSize: '12px', color: '#6C757D', fontFamily: 'Montserrat', fontWeight: 400 }}>
                                                                                                {subtitle}
                                                                                            </div>
                                                                                        )}
                                                                                    </div>
                                                                                    {isSelected && (
                                                                                        <svg
                                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                                            width="20"
                                                                                            height="20"
                                                                                            viewBox="0 0 20 20"
                                                                                            fill="none"
                                                                                            style={{ flexShrink: 0, marginLeft: 8 }}
                                                                                        >
                                                                                            <path
                                                                                                d="M16.6668 5L7.50016 14.1667L3.3335 10"
                                                                                                stroke="#6C757D"
                                                                                                strokeWidth="2"
                                                                                                strokeLinecap="round"
                                                                                                strokeLinejoin="round"
                                                                                            />
                                                                                        </svg>
                                                                                    )}
                                                                                </div>
                                                                            );
                                                                        });
                                                                    })()}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Footer */}
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'flex-end',
                                                        alignItems: 'center',
                                                        gap: '50px',
                                                        padding: '20px 4px',
                                                    }}
                                                >
                                                    <button
                                                        onClick={() => {
                                                            setSelectedStatuses([]);
                                                            setSelectedParentBrands([]);
                                                            setTempParentBrands([]);
                                                            setTempStatuses([]);
                                                            setParentBrandDropdownOpen(false);
                                                            // setFilterPopupOpen(false);
                                                        }}
                                                        style={{
                                                            background: 'none',
                                                            border: 'none',
                                                            width: '140px',
                                                            color: '#000',
                                                            fontFamily: 'Montserrat',
                                                            fontSize: '12px',
                                                            fontStyle: 'normal',
                                                            lineHeight: 'normal',
                                                            fontWeight: '600',
                                                        }}
                                                    >
                                                        Clear
                                                    </button>

                                                    <div style={{ display: 'flex', gap: '8px' }}>
                                                        <button
                                                            onClick={handleCloseFilterPopup}
                                                            style={{
                                                                background: 'var(--Background-White, #FFF)',
                                                                // border: 'none',
                                                                borderRadius: '8px',
                                                                // cursor: 'pointer',
                                                                fontWeight: '500',
                                                                display: 'flex',
                                                                height: '34px',
                                                                minWidth: '100px',
                                                                padding: '10px',
                                                                justifyContent: 'center',
                                                                alignItems: 'center',
                                                                gap: '10px',
                                                                boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.10)',
                                                                border: '1px solid var(--navbar-dropdown-active, #212529)',
                                                                color: 'var(--navbar-dropdown-active, #212529)',
                                                                fontFamily: 'Montserrat',
                                                                fontSize: '12px',
                                                                fontStyle: 'normal',
                                                                lineHeight: 'normal',
                                                                fontWeight: '600',
                                                            }}
                                                        >
                                                            Cancel
                                                        </button>
                                                        <button
                                                            onClick={() => {
                                                                setSelectedStatuses(tempStatuses);
                                                                setSelectedParentBrands(tempParentBrands);
                                                                setParentBrandDropdownOpen(false);
                                                                setFilterPopupOpen(false);
                                                            }}
                                                            style={{
                                                                display: 'flex',
                                                                height: '34px',
                                                                minWidth: '100px',
                                                                padding: '10px',
                                                                justifyContent: 'center',
                                                                alignItems: 'center',
                                                                gap: '10px',
                                                                background: ' #212529',
                                                                borderRadius: '8px',
                                                                boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.10)',
                                                                fontFamily: 'Montserrat',
                                                                fontSize: '12px',
                                                                fontStyle: 'normal',
                                                                lineHeight: 'normal',
                                                                fontWeight: '600',
                                                                color: ' #FFF',
                                                            }}
                                                        >
                                                            Filter
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                    <div className="table-wrapper" style={{ border: "none" }}>
                                        <DynamicTable
                                            columns={columns}
                                            data={pageData.filter((row) => !row.is_archived)}
                                            sortField={sortField}
                                            sortOrder={sortOrder}
                                            handleSort={handleSort}
                                            onRowClick={onRowClick}
                                            onActionClick={toggleDropdown}
                                            noImage={noImage}
                                            selectedIds={selectedIds}
                                            dropdownOpenId={dropdownOpenId}
                                            suppressHighlight={suppressHighlight}
                                            buttonRefs={buttonRefs}
                                            rowKey="brand_id"
                                            searchTerm={searchTerm}
                                            selectedStatuses={selectedStatuses}
                                            selectedParentBrands={selectedParentBrands}
                                            emptyImage={emptyImage}
                                            emptyTitle={emptyTitle}
                                            emptyMessage={emptyMessage}
                                            showActions={true}
                                            stickyColumns={1}
                                            resizableColumns={true}
                                        />
                                        {dropdownOpenId !== null && currentRow && (
                                            <div
                                                ref={dropdownRef}
                                                className="backdrop-cls"
                                                style={{
                                                    position: "absolute",
                                                    top: dropdownPosition.top,
                                                    left: dropdownPosition.left,
                                                    background: "white",
                                                    boxShadow: "0px 1px 4px 0px #0000001A",
                                                    zIndex: 1000,
                                                    minWidth: 152,
                                                    borderRadius: 8,
                                                }}
                                                onClick={e => e.stopPropagation()}
                                            >
                                                <div className="btn-align-forall">
                                                    <div className="common-for-all">
                                                        <button onClick={
                                                            () => {
                                                                const row = pageData.find(d => d.brand_id === dropdownOpenId);
                                                                onRowClick(row);
                                                                setDropdownOpenId(null);
                                                            }
                                                        }>
                                                            View Details
                                                        </button>
                                                    </div>
                                                    <div className="common-for-all">
                                                        <button
                                                            onClick={editBrand}
                                                        >Edit</button>
                                                    </div>
                                                    <div className="common-for-all">
                                                        {currentRow && (
                                                            <button
                                                                onClick={() => {
                                                                    if (currentRow.status_text === "Active") {
                                                                        // Active → show confirmation modal
                                                                        setDeactivateModalOpen(true);
                                                                        setSelectedBrandId(currentRow.brand_id);
                                                                    } else {
                                                                        // Inactive → activate directly
                                                                        handleDeactivateBrand(currentRow.brand_id);
                                                                    }
                                                                    // Close table dropdown
                                                                    setDropdownOpenId(null);
                                                                }}
                                                            >
                                                                {currentRow.status_text === "Active" ? "Deactivate" : "Activate"}
                                                            </button>
                                                        )}

                                                    </div>
                                                    <div className="common-for-all">
                                                        <button onClick={() => {
                                                            const row = pageData.find(d => d.brand_id === dropdownOpenId);
                                                            openArchiveModal(row.brand_id);
                                                            setDropdownOpenId(null);
                                                        }} className="deactivate-cls">
                                                            Archive
                                                        </button>

                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    {deactivateModalOpen && (
                                        <ConfirmDeactivateModal
                                            isOpen={deactivateModalOpen}
                                            onCancel={() => setDeactivateModalOpen(false)}
                                            onConfirm={() => {
                                                handleDeactivateBrand(selectedBrandId);
                                            }}
                                            entityName="Brand"
                                        />
                                    )}
                                    {archivedModalOpen && (
                                        <ConfirmArchiveModal
                                            isOpen={archivedModalOpen}
                                            onCancel={() => setArchivedModalOpen(false)}
                                            onConfirm={() => handleArchivedConfirm(selectedBrandId)} // ✅ confirm action
                                            entityName="Brand"
                                        />
                                    )}
                                    {totalCount > 0 && (
                                        <div className="pagination">
                                            <div className="pagination-info">
                                                {` ${(currentPage - 1) * PAGE_SIZE + 1} - ${Math.min(currentPage * PAGE_SIZE, totalCount)} of ${totalCount}`}
                                            </div>
                                            <Pagination
                                                currentPage={currentPage}
                                                totalPages={totalPages}
                                                onPageChange={setCurrentPage}
                                            />
                                        </div>
                                    )}

                                    {saveModalOpen && (
                                        <>
                                            <div className="drawer-overlay" />
                                            <div
                                                className="entity-drawer modal-popup-cls"
                                                ref={saveRef}
                                                style={{
                                                    maxWidth: 650,
                                                    margin: "0 auto",
                                                    background: "white",
                                                    borderRadius: 12,
                                                    zIndex: 1050,
                                                    padding: 24,
                                                    position: "fixed",
                                                    top: "50%",
                                                    left: "50%",
                                                    transform: "translate(-50%, -50%)",
                                                    boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                                                    height: "auto",
                                                    right: "auto",
                                                    overflow: "inherit",
                                                }}
                                            >
                                                <div className="drawer-header d-flex justify-content-end align-items-center pt-0 pe-0">
                                                    <button className="close-btn" onClick={() => setSaveModalOpen(false)}>
                                                        <X size={20} />
                                                    </button>
                                                </div>
                                                <h3 style={{ textAlign: "left", color: "#212529", fontSize: "20px", fontWeight: "600", lineHeight: "24px", fontFamily: "Montserrat", marginBottom: "5px" }}>New feature in Progress</h3>
                                                <p style={{ marginBottom: "0", textAlign: "left", color: "#6C757D", fontSize: "14px", fontWeight: "400", lineHeight: "20px", fontFamily: "Montserrat" }}>Work in Progress</p>
                                                <div className="drawer-footer" style={{ paddingTop: "10px" }}>
                                                    <button className="btn-save" onClick={handleSaveConfirm}>
                                                        OK
                                                    </button>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* Drawer with combined General tab */}
                        {drawerOpen && selectedRow && (
                            <>
                                <div className="drawer-overlay" />
                                <div className="entity-drawer" ref={drawerRef}>
                                    <div className="drawer-header" style={{ backgroundColor: "#F8F9FA" }}>
                                        <div className="d-flex align-items-center gap-1">
                                            {(brandStack.length > 1 || location.search.includes('from=spusku')) && (
                                                <button
                                                    className="back-btn"
                                                    onClick={() => {
                                                        if (brandStack.length > 1) {
                                                            handleBackToPreviousBrand();
                                                            return;
                                                        }
                                                        if (location.search.includes('from=spusku')) {
                                                            const query = new URLSearchParams(location.search);
                                                            const spuId = query.get('spuId');
                                                            const spuTab = query.get('spuTab');
                                                            history.push(`/spu-sku?id=${spuId}&autoOpen=true&tab=${spuTab}`);
                                                            setDrawerOpen(false);
                                                            setSelectedRow(null);
                                                            setHasAutoOpened(false);
                                                            setPreviousBrand(null);
                                                            setBrandStack([]);
                                                        } else {
                                                            handleBackToPreviousBrand();
                                                        }
                                                    }}
                                                    style={{ backgroundColor: 'transparent', border: 'none', padding: 0, margin: 0 }}
                                                >
                                                    <ChevronLeft size={24} />
                                                </button>
                                            )}
                                            <h3>Brand Info</h3>
                                        </div>
                                        <button
                                            className="close-btn"
                                            onClick={() => {
                                                setDrawerOpen(false);
                                                setSelectedIds(ids => ids.filter(id => id !== selectedRow?.brand_id));
                                                setSelectedRow(null);
                                                setHasAutoOpened(false);
                                                setBrandStack([]);
                                            }}
                                        >
                                            <X size={18} />
                                        </button>
                                    </div>
                                    <div className="main-drawer-inner">
                                        <div className="drawer-title d-flex align-items-center justify-content-between"
                                            style={{
                                                borderBottom: "none",
                                                paddingBottom: "0px",
                                                boxShadow: "none",
                                                marginBottom: "0px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                                flexWrap: "nowrap",
                                                width: "100%",
                                            }}
                                        >
                                            <div className='d-flex align-items-center'>
                                                <img
                                                    src={selectedRow.original_logo_url || noImage}
                                                    alt="avatar"
                                                    className="avatar"
                                                    style={{
                                                        width: 40,
                                                        height: 40,
                                                        // borderRadius: '50%',
                                                        marginRight: 8,
                                                        verticalAlign: 'middle'
                                                    }}
                                                
                                                    onError={(e) => { e.target.src = noImage; }}
                                                />
                                                <h2 style={{ textTransform: 'none', }} className='pb-0'

                                                >{selectedRow?.brand_name}</h2>
                                            </div>
                                            <div className='entities-tab'>
                                                <div className='toolbar'>
                                                    <div className='toolbar-right' style={{
                                                        position: "relative", flexWrap: "nowrap"

                                                    }} ref={toolbarRef}>
                                                        <div className='edit-organisation-info d-flex justify-content-end align-items-center gap-2'
                                                            style={{
                                                                flexShrink: 0,              // ✅ prevents collapse
                                                                whiteSpace: 'nowrap',       // ✅ keeps buttons inline
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: '8px',
                                                            }}

                                                        >
                                                            <button
                                                                className="dark-border gray-btn"
                                                                type='button'
                                                                onClick={editBrand}
                                                                style={{ width: '100px' }}
                                                            >
                                                                Edit
                                                            </button>
                                                        </div>
                                                        <button
                                                            className="drawer-dots"
                                                            style={{ boxShadow: 'none' }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                toggleToolbarDropdown();
                                                            }}
                                                        >
                                                            <MoreHorizontal size={18} />
                                                        </button>
                                                        {toolbarDropdownOpen && (
                                                            <div
                                                                className="backdrop-cls"
                                                                style={{
                                                                    position: "absolute",
                                                                    top: 40,
                                                                    right: 0,
                                                                    background: "white",
                                                                    boxShadow: "0px 1px 4px 0px #0000001A",
                                                                    zIndex: 1000,
                                                                    minWidth: 152,
                                                                    borderRadius: 8,
                                                                }}
                                                                onClick={(e) => e.stopPropagation()}
                                                            >
                                                                <div className="btn-align-forall">
                                                                    <div className="common-for-all">
                                                                        <button
                                                                            onClick={() => {
                                                                                if (selectedRow.status_text === 'Active') {
                                                                                    // Active → show confirmation modal
                                                                                    setDeactivateModalOpen(true);
                                                                                    setSelectedBrandId(selectedRow.brand_id);
                                                                                    setToolbarDropdownOpen(false);
                                                                                } else {
                                                                                    // Inactive → activate directly
                                                                                    handleDeactivateBrand(selectedRow.brand_id);
                                                                                    setToolbarDropdownOpen(false);
                                                                                }
                                                                                setToolbarDropdownOpen(false);
                                                                            }}
                                                                        >
                                                                            {selectedRow.status_text === 'Active' ? 'Deactivate' : 'Activate'}
                                                                        </button>
                                                                    </div>
                                                                    <div className="common-for-all">
                                                                        <button
                                                                            onClick={() => {
                                                                                const row = pageData.find(d => d.brand_id === selectedRow.brand_id);
                                                                                if (row) {
                                                                                    openArchiveModal(row.brand_id);
                                                                                    setToolbarDropdownOpen(false);
                                                                                } else {
                                                                                    console.warn('Row not found for brand_id:', selectedRow.brand_id);
                                                                                }
                                                                            }}
                                                                            className="deactivate-cls"
                                                                        >
                                                                            Archive
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="drawer-tabs"
                                            style={{
                                                padding: " 20px",           // optional: top/bottom 0, left/right 20px
                                                borderBottom: "1px solid #E9ECEF",
                                                gap: "20px",
                                                marginBottom: "20px",
                                            }}

                                        >
                                            <button
                                                className={drawerTab === 'general' ? 'active' : ''}
                                                onClick={() => setDrawerTab('general')}
                                            >
                                                General
                                            </button>
                                            <button
                                                className={drawerTab === 'additional-info' ? 'active' : ''}
                                                onClick={() => setDrawerTab('additional-info')}
                                            >
                                                Additional
                                            </button>
                                        </div>
                                        <div className="drawer-content">
                                            {drawerTab === 'general' && (
                                                <div className="tab-panel general-panel">

                                                    {/* ===== BASIC INFO CARD ===== */}
                                                    <div
                                                        className="card-section"
                                                        style={{
                                                            borderRadius: '12px',
                                                            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.08)', // subtle elevation
                                                            overflow: 'hidden',
                                                            marginBottom: '20px',
                                                            marginTop: '20px',
                                                        }}
                                                    >
                                                        {/* HEADER */}
                                                        <div
                                                            className="card-header"
                                                            style={{
                                                                backgroundColor: ' #F8F9FA',
                                                                padding: '15px 20px',
                                                                fontFamily: 'Montserrat',
                                                                fontSize: '14px',
                                                                fontWeight: 600,
                                                                color: ' #212529',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                alignSelf: 'stretch',
                                                                borderRadius: '12px 12px 0px 0px',
                                                                gap: '10px',
                                                                height: '50px',
                                                            }}
                                                        >
                                                            Basic Info
                                                        </div>

                                                        {/* BODY */}
                                                        <div
                                                            className="card-body"
                                                            style={{
                                                                backgroundColor: '#FFFFFF',
                                                                padding: '16px',
                                                                display: 'grid',
                                                                gridTemplateColumns: 'repeat(2, 1fr)',
                                                                gap: '16px',
                                                            }}
                                                        >

                                                            <div className="field-block" style={{
                                                                borderBottom: 'none',
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                minHeight: '60px',
                                                                gridColumn: isBrandNameOverflowing(selectedRow.brand_name) ? '1 / -1' : '1',
                                                                gridRow: '1'
                                                            }}>
                                                                <div className="field-label">Brand Name</div>
                                                                <div className="field-value" style={{
                                                                    wordWrap: 'break-word',
                                                                    overflowWrap: 'break-word',
                                                                    whiteSpace: 'normal'
                                                                }}>
                                                                    {selectedRow.brand_name || <span style={{ color: '#ADB5BD' }}>NA</span>}
                                                                </div>
                                                            </div>

                                                            {/* Status Field - Position depends on Category Name length */}
                                                            <div className="field-block" style={{
                                                                borderBottom: 'none',
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                minHeight: '60px',
                                                                gridColumn: isBrandNameOverflowing(selectedRow.brand_name) ? '1' : '2',
                                                                gridRow: isBrandNameOverflowing(selectedRow.brand_name) ? '2' : '1'
                                                            }}>
                                                                <div className="field-label">Status</div>
                                                                <div className="field-value">
                                                                    <span className={`status ${typeof selectedRow?.status_text === 'string' ? selectedRow.status_text?.toLowerCase() : ''}`}>
                                                                        {selectedRow.status_text || <span style={{ color: '#ADB5BD' }}>NA</span>}
                                                                    </span>
                                                                </div>
                                                            </div>

                                                            <div
                                                                className="field-block"
                                                                style={{
                                                                    borderBottom: 'none',
                                                                    padding: '9px 0',
                                                                    gridColumn: '1 / -1', // ✅ span both columns
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    alignItems: 'flex-start',
                                                                    width: '100%',
                                                                }}>
                                                                <div className="field-label" style={{ marginBottom: '4px' }}>ID</div>
                                                                <div className="field-value" style={{ width: '100%', wordBreak: 'break-all' }}>
                                                                    {selectedRow.external_id || <span style={{ color: '#ADB5BD' }}>NA</span>}
                                                                </div>
                                                            </div>

                                                            <div
                                                                className="field-block"
                                                                style={{
                                                                    borderBottom: 'none',
                                                                    padding: '9px 0',
                                                                    gridColumn: '1 / -1', // ✅ span both columns
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    alignItems: 'flex-start',
                                                                    width: '100%',
                                                                }}
                                                            >
                                                                <div className="field-label" style={{ marginBottom: '4px' }}>Open ID</div>
                                                                <div className="field-value" style={{ width: '100%', wordBreak: 'break-all' }}>
                                                                    {selectedRow.uuid ? (
                                                                        <div className="field-value d-flex align-items-center gap-2">
                                                                            <span
                                                                                style={{
                                                                                    color: '#2C7BE5',
                                                                                    cursor: 'pointer',
                                                                                    textDecoration: 'underline',
                                                                                }}
                                                                                onClick={() => handleCopy(selectedRow.uuid)}
                                                                            >
                                                                                {selectedRow.uuid}
                                                                                <Copy
                                                                                    size={13}
                                                                                    onClick={() => handleCopy(selectedRow.uuid)}
                                                                                    style={{ cursor: 'pointer', color: '#2C7BE5', marginLeft: '6px', }}
                                                                                />
                                                                            </span>
                                                                            {copied && (
                                                                                <span style={{ fontSize: '12px', color: '#2C7BE5' }}>
                                                                                    Copied!
                                                                                </span>
                                                                            )}
                                                                        </div>
                                                                    ) : (
                                                                        <span style={{ color: '#ADB5BD' }}>NA</span>
                                                                    )}
                                                                </div>
                                                            </div>

                                                            <div className="field-block" style={{ borderBottom: 'none', padding: "9px 0px " }}>
                                                                <div className="field-label">Created By</div>
                                                                <div className="field-value">{selectedRow.created_by_name || <span style={{ color: '#ADB5BD' }}>NA</span>}</div>
                                                            </div>

                                                            <div className="field-block" style={{ borderBottom: 'none', padding: "9px 0px " }}>
                                                                <div className="field-label">Created Time</div>
                                                                <div className="field-value">
                                                                    {formatDateTime(selectedRow.created_at) || <span style={{ color: '#ADB5BD' }}>NA</span>}
                                                                </div>
                                                            </div>

                                                            <div className="field-block" style={{ borderBottom: 'none', padding: "9px 0px " }}>
                                                                <div className="field-label">Last Modified By</div>
                                                                <div className="field-value">
                                                                    {selectedRow.modified_by_name || <span style={{ color: '#ADB5BD' }}>NA</span>}
                                                                </div>
                                                            </div>

                                                            <div className="field-block" style={{ borderBottom: 'none', padding: "9px 0px " }}>
                                                                <div className="field-label">Last Modified Time</div>
                                                                <div className="field-value">
                                                                    {formatDateTime(selectedRow.modified_at) || <span style={{ color: '#ADB5BD' }}>NA</span>}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* ===== BUSINESS INFO CARD ===== */}
                                                    <div
                                                        className="card-section"
                                                        style={{
                                                            borderRadius: '12px',
                                                            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.08)',
                                                            overflow: 'hidden',
                                                        }}
                                                    >
                                                        <div
                                                            className="card-header"
                                                            style={{
                                                                backgroundColor: '#F8F9FA',
                                                                padding: '10px 16px',
                                                                fontFamily: 'Montserrat',
                                                                fontSize: '14px',
                                                                fontWeight: 600,
                                                                color: '#212529',
                                                            }}
                                                        >
                                                            Business Info
                                                        </div>

                                                        <div
                                                            className="card-body"
                                                            style={{
                                                                backgroundColor: '#FFFFFF',
                                                                padding: '16px',
                                                                display: 'grid',
                                                                gridTemplateColumns: 'minmax(150px, 1fr) 1fr', // ✅ flexible first column
                                                                gap: '16px',
                                                                wordBreak: 'break-word',       // ✅ forces long words to break
                                                                overflowWrap: 'break-word',
                                                                whiteSpace: 'normal',
                                                            }}
                                                        >
                                                            <div className="field-block"
                                                                style={{
                                                                    borderBottom: 'none',
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    minHeight: '60px',
                                                                    gridColumn: isBrandNameOverflowing(selectedRow.parent_name) ? '1 / -1' : '1',
                                                                    gridRow: '1',
                                                                    padding: '9px 0px',
                                                                }}
                                                            >
                                                                <div className="field-label">Parent Brand</div>
                                                                <div className="field-value">
                                                                    {selectedRow.parent_name && selectedRow.parent_name !== <span style={{ color: '#ADB5BD' }}>NA</span> ? (
                                                                        (() => {
                                                                            const parentBrandObj = brandsData.find(
                                                                                (d) => d.brand_id === selectedRow.parent_brand
                                                                            );
                                                                            const parentLogo =
                                                                                parentBrandObj?.original_logo_url || noImage;

                                                                            return (
                                                                                <div className="d-flex align-items-center" >
                                                                                    <img
                                                                                        src={parentLogo}
                                                                                        alt="parent brand logo"
                                                                                        className="avatar"
                                                                                        onError={(e) => {
                                                                                            e.target.onerror = null;
                                                                                            e.target.src = noImage;
                                                                                        }}
                                                                                        style={{
                                                                                            width: 32,
                                                                                            height: 32,
                                                                                            marginRight: 10,
                                                                                            flexShrink: 0,
                                                                                            verticalAlign: 'middle',
                                                                                        }}
                                                                                    />
                                                                                    {parentBrandObj?.status ? (

                                                                                        <div
                                                                                            className="me-3"
                                                                                            style={{
                                                                                                color: '#2C7BE5',
                                                                                                textDecoration: 'underline',
                                                                                                fontWeight: 600,
                                                                                                fontSize: '12px',
                                                                                                cursor: 'pointer',
                                                                                                lineHeight: '1.4',
                                                                                                maxWidth: '100%',
                                                                                                wordBreak: 'break-word',
                                                                                                overflowWrap: 'anywhere',
                                                                                                whiteSpace: 'normal',

                                                                                            }}
                                                                                            onClick={() => {
                                                                                                if (parentBrandObj) {
                                                                                                    handleParentBrandClick(parentBrandObj?.brand_id);
                                                                                                } else {
                                                                                                    console.warn('Parent brand not found in brandsData');
                                                                                                }
                                                                                            }}
                                                                                        >
                                                                                            {/* ✅ text and icon in same inline flow */}
                                                                                            <span style={{ display: 'inline', wordBreak: 'break-word' }}>
                                                                                                {selectedRow.parent_name}

                                                                                                <SquareArrowOutUpRight
                                                                                                    size={14}
                                                                                                    strokeWidth={3}
                                                                                                    style={{
                                                                                                        marginLeft: '4px',
                                                                                                        verticalAlign: 'text-top', // ✅ aligns nicely with text
                                                                                                        color: '#2C7BE5',
                                                                                                    }}
                                                                                                    onClick={(e) => {
                                                                                                        e.stopPropagation();
                                                                                                        if (parentBrandObj) {
                                                                                                            handleParentBrandClick(parentBrandObj.brand_id);
                                                                                                        } else {
                                                                                                            console.warn('Parent brand not found in brandsData');
                                                                                                        }
                                                                                                    }}
                                                                                                />
                                                                                            </span>
                                                                                        </div>
                                                                                    ) : <span style={{ color: '#ADB5BD' }}>NA</span>}
                                                                                </div>



                                                                            );
                                                                        })()
                                                                    ) : (
                                                                        <span style={{ color: '#ADB5BD' }}>NA</span>
                                                                    )}
                                                                </div>
                                                            </div>

                                                            <div className="field-block"
                                                                style={{
                                                                    borderBottom: 'none',
                                                                    padding: '9px 0px',
                                                                    wordBreak: 'break-word',       // ✅ added
                                                                    overflowWrap: 'break-word',
                                                                    whiteSpace: 'normal',
                                                                }}

                                                            >
                                                                <div className="field-label">Prefix</div>
                                                                <div className="field-value">{selectedRow.prefix || <span style={{ color: '#ADB5BD' }}>NA</span>}</div>
                                                            </div>

                                                            <div
                                                                className="field-block"
                                                                style={{
                                                                    borderBottom: 'none',
                                                                    padding: '9px 0',
                                                                    gridColumn: '1 / -1', // ✅ span both columns
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    alignItems: 'flex-start',
                                                                    width: '100%',
                                                                }}>
                                                                <div className="field-label" style={{ marginBottom: '4px' }}>Logo</div>
                                                                <div className="field-value" style={{ width: '100%', wordBreak: 'break-all' }}>
                                                                    <img
                                                                        src={selectedRow.original_logo_url || noImage}
                                                                        alt="avatar"
                                                                        className="avatar"
                                                                        style={{
                                                                            // maxWidth: 100,
                                                                            cursor: 'pointer',
                                                                            // borderRadius: '8px',
                                                                            width: 32,
                                                                            height: 32
                                                                        }}
                                                                        onClick={() => setImageModalOpen(true)}
                                                                    
                                                                        onError={(e) => { e.target.src = noImage; }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            {imageModalOpen && (
                                                <>
                                                    <div className="drawer-overlay" style={{ zIndex: 1100 }} />
                                                    <div
                                                        className="image-modal"
                                                        style={{
                                                            position: 'fixed',
                                                            top: '50%',
                                                            left: '50%',
                                                            transform: 'translate(-50%, -50%)',
                                                            background: 'white',
                                                            borderRadius: '12px',
                                                            boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
                                                            zIndex: 1101,
                                                            maxWidth: '90%',
                                                            maxHeight: '90%',
                                                            overflow: 'auto'
                                                        }}
                                                    >
                                                        <div style={{ position: 'relative' }}>
                                                            <button
                                                                className="close-btn"
                                                                onClick={() => setImageModalOpen(false)}
                                                                style={{
                                                                    position: 'absolute',
                                                                    top: '10px',
                                                                    right: '10px',
                                                                    background: 'none',
                                                                    border: 'none',
                                                                    cursor: 'pointer'
                                                                }}
                                                            >
                                                                <X size={24} />
                                                            </button>
                                                            <img
                                                                src={selectedRow.original_logo_url || noImage}
                                                                alt="avatar"
                                                                style={{
                                                                    maxWidth: '100%',
                                                                    maxHeight: '80vh',
                                                                    display: 'block'
                                                                }}
                                                            
                                                                onError={(e) => { e.target.src = noImage; }}
                                                            />
                                                        </div>
                                                    </div>
                                                </>
                                            )}

                                            {drawerTab === 'additional-info' && (
                                                <div
                                                    className="card-section"
                                                    style={{
                                                        borderRadius: '12px',
                                                        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.08)',
                                                        overflow: 'hidden',
                                                        marginTop: '40px',
                                                    }}
                                                >
                                                    {/* ✅ Header: same style as Business Info */}
                                                    <div
                                                        className="card-header "
                                                        style={{
                                                            backgroundColor: '#F8F9FA',
                                                            padding: '10px 16px',
                                                            fontFamily: 'Montserrat',
                                                            fontSize: '14px',
                                                            fontWeight: 600,
                                                            color: '#212529',
                                                        }}
                                                    >
                                                        Notes
                                                    </div>

                                                    {/* ✅ Body: matches layout and spacing */}
                                                    <div
                                                        className="card-body"
                                                        style={{
                                                            backgroundColor: '#FFFFFF',
                                                            padding: '16px',
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            gap: '12px',
                                                            wordBreak: 'break-word',
                                                            overflowWrap: 'break-word',
                                                            whiteSpace: 'normal',
                                                        }}
                                                    >
                                                        <div className="field-block">
                                                            <div
                                                                className="field-value notes-preserve"
                                                                style={{
                                                                    background: '#FFFFFF',
                                                                    padding: '8px 0',
                                                                    fontSize: '13px',
                                                                    color: selectedRow.notes ? '#212529' : '#ADB5BD',
                                                                    minHeight: '24px',
                                                                }}
                                                            >
                                                                {selectedRow.notes || 'NA'}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}


                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                        {spuLinkedModalOpen && (
                            <>
                                <div className="drawer-overlay" />
                                <div
                                    className="entity-drawer modal-popup-cls"
                                    ref={archivedRef}
                                    style={{
                                        maxWidth: 650,
                                        margin: "0 auto",
                                        background: "white",
                                        borderRadius: 12,
                                        zIndex: 1050,
                                        padding: 24,
                                        position: "fixed",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                                        height: "auto",
                                        right: "auto",
                                        overflow: "inherit",
                                    }}
                                >
                                    <div className="drawer-header d-flex justify-content-end align-items-center pt-0 pe-0">
                                        <button className="close-btn" onClick={() => setSpuLinkedModalOpen(false)}>
                                            <X size={20} />
                                        </button>
                                    </div>
                                    <h3
                                        style={{
                                            textAlign: "left",
                                            color: "#212529",
                                            fontSize: "20px",
                                            fontWeight: "600",
                                            lineHeight: "24px",
                                            fontFamily: "Montserrat",
                                            marginBottom: "5px",
                                        }}
                                    >
                                        The brand can't be archived
                                    </h3>
                                    <p
                                        style={{
                                            marginBottom: "0",
                                            textAlign: "left",
                                            color: "#6C757D",
                                            fontSize: "14px",
                                            fontWeight: "400",
                                            lineHeight: "20px",
                                            fontFamily: "Montserrat",
                                        }}
                                    >
                                        {linkedModalMessage}
                                    </p>
                                    <div className="drawer-footer" style={{ paddingTop: "10px" }}>
                                        <button className="btn-save" onClick={() => setSpuLinkedModalOpen(false)}>
                                            OK
                                        </button>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                )}

                {activeTab === 'archived-brands' && (
                    <div className="tab-content" id="archived-brands-content">
                        <div className="info-section">
                            <div className="info-card">
                                <div className="entities-tab">
                                    <div className="toolbar">
                                        <div className="toolbar-left">
                                            <SearchBox
                                                searchInput={archivedSearchInput}
                                                setSearchInput={setArchivedSearchInput}
                                                setSearchTerm={setArchivedSearchTerm}
                                                setCurrentPage={setArchivedCurrentPage}
                                                disabled={isArchivedEmptyState}
                                            />
                                            <button
                                                ref={archivedFilterButtonRef}
                                                disabled={isArchivedEmptyState}
                                                className={`icon-btn p-2 filter-btn ${archivedFiltersApplied ? 'applied' : ''}`}
                                                onClick={() => {
                                                    !isArchivedEmptyState && setArchivedFilterPopupOpen(!archivedFilterPopupOpen);
                                                }}
                                                style={{
                                                    border: isArchivedEmptyState
                                                        ? '1px solid var(--Gray-400, #CED4DA)'
                                                        : archivedFiltersApplied
                                                            ? '1px solid #2C7BE5'
                                                            : '1px solid #6C757D',
                                                    borderWidth: '1px',
                                                    color: isArchivedEmptyState ? '#CED4DA' : archivedFiltersApplied ? '#2C7BE5' : '#6C757D',
                                                    background: isArchivedEmptyState
                                                        ? 'var(--Gray-100, #F8F9FA)'
                                                        : archivedFiltersApplied
                                                            ? '#CFE2FF'
                                                            : '#FFFFFF',
                                                    height: '40px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    cursor: isArchivedEmptyState ? 'not-allowed' : 'pointer',
                                                    pointerEvents: isArchivedEmptyState ? 'none' : 'auto',
                                                }}
                                            >
                                                {isArchivedEmptyState ? (
                                                    <FilterDisabledIcon />
                                                ) : archivedFiltersApplied ? (
                                                    <FilterActiveIcon />
                                                ) : (
                                                    <FilterInactiveIcon />
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                    {/* Archived Filter Popup */}
                                    {archivedFilterPopupOpen && (
                                        <>
                                            {/* 🔒 Overlay to freeze background */}
                                            <div
                                                onClick={handleCloseArchivedFilterPopup} // close when clicking outside
                                                style={{
                                                    position: 'fixed',
                                                    top: 0,
                                                    left: 0,
                                                    width: '100vw',
                                                    height: '100vh',
                                                    backgroundColor: 'rgba(0,0,0,0.4)',
                                                    zIndex: 1500,
                                                    padding: '20px'
                                                }}
                                            />

                                            <div
                                                style={{
                                                    position: 'fixed',
                                                    top: 0,
                                                    right: 0,
                                                    width: 400,
                                                    boxSizing: 'border-box',
                                                    height: '100vh',
                                                    backgroundColor: '#fff',
                                                    boxShadow: '-3px 0 12px rgba(0,0,0,0.1)',
                                                    zIndex: 2000,
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    animation: 'slideIn 0.3s ease-out',
                                                }}
                                            >
                                                {/* Header */}
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        height: '60px',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center',
                                                        alignSelf: 'stretch',
                                                        padding: '15px 20px',
                                                        background: '#F8F9FA'
                                                    }}
                                                >
                                                    <h4 style={{ margin: 0, fontWeight: 600, color: ' #212529', fontFamily: 'Montserrat', fontSize: '14px', fontStyle: 'normal', lineHeight: 'normal' }}>Archived  Filter</h4>
                                                    <button
                                                        onClick={handleCloseArchivedFilterPopup}
                                                        style={{
                                                            background: 'none',
                                                            border: 'none',
                                                            cursor: 'pointer',
                                                            padding: '4px',
                                                        }}
                                                    >
                                                        <X size={18} />
                                                    </button>
                                                </div>

                                                {/* Body */}
                                                <div
                                                    style={{
                                                        flex: 1,
                                                        overflowY: 'auto',
                                                        padding: '20px',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        gap: '24px',
                                                    }}
                                                >

                                                    <div ref={archivedDropdownRef}>
                                                        <label
                                                            style={{
                                                                display: "block",
                                                                fontWeight: 600,
                                                                marginBottom: "8px",
                                                                color: ' #212529',
                                                                fontFamily: 'Montserrat',
                                                                fontSize: '14px',
                                                                fontStyle: 'normal',
                                                                lineHeight: 'normal'
                                                            }}
                                                        >
                                                            Parent Brand
                                                        </label>

                                                        {/* Search Input + Chips */}
                                                        <div
                                                            className="search-box-filter"
                                                            style={{
                                                                position: "relative",
                                                                border: "1px solid #6C757D",
                                                                borderRadius: "8px",
                                                                padding: "4px 8px",
                                                                display: "flex",
                                                                flexWrap: "wrap",
                                                                alignItems: "center",
                                                                gap: "6px",
                                                                minHeight: "36px",
                                                                backgroundColor: "#fff",
                                                                whiteSpace: "normal",
                                                                wordBreak: "break-word",
                                                                paddingRight: "32px"
                                                            }}
                                                            onClick={() => setArchivedParentBrandDropdownOpen(true)} // opens dropdown when clicking inside
                                                        >

                                                            {/* Selected Chips */}
                                                            {tempArchivedParentBrands.map((parent) => {
                                                                if (!parent) return null;
                                                                return (
                                                                    <span
                                                                        key={parent}
                                                                        style={{
                                                                            backgroundColor: "#ffeb00",
                                                                            color: "#212529",
                                                                            borderRadius: "16px",
                                                                            padding: "4px 8px",
                                                                            display: "inline-flex",
                                                                            alignItems: "center",
                                                                            fontSize: "12px",
                                                                            fontWeight: "600",
                                                                            fontFamily: "Montserrat",
                                                                            paddingRight: "24px"
                                                                        }}
                                                                    >
                                                                        {parent}
                                                                        <button
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                handleArchivedCheckboxChange(setTempArchivedParentBrands, parent)({
                                                                                    target: { checked: false },
                                                                                });
                                                                            }}
                                                                            style={{
                                                                                background: "none",
                                                                                border: "none",
                                                                                marginLeft: "6px",
                                                                                cursor: "pointer",
                                                                                padding: "0",
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                            }}
                                                                        >
                                                                            <X size={14} strokeWidth={3} />
                                                                        </button>
                                                                    </span>
                                                                );
                                                            })}

                                                            {/* Search Input */}
                                                            <div style={{ flex: 1, display: "flex", alignItems: "center" }}>
                                                                <input
                                                                    type="text"
                                                                    value={archivedParentBrandSearchTerm}
                                                                    onChange={(e) => {
                                                                        setArchivedParentBrandSearchTerm(e.target.value);
                                                                        if (!archivedParentBrandDropdownOpen) {
                                                                            setArchivedParentBrandDropdownOpen(true);
                                                                        }
                                                                    }}
                                                                    onFocus={() => setArchivedParentBrandDropdownOpen(true)}
                                                                    style={{
                                                                        border: "none",
                                                                        outline: "none",
                                                                        width: "100%",
                                                                        fontSize: "14px",
                                                                        background: "transparent",
                                                                        minWidth: "100px",
                                                                        color: "#212529",
                                                                    }}
                                                                />
                                                            </div>

                                                            {/* Dropdown Toggle Icon (chevron) */}
                                                            <div
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    setArchivedParentBrandDropdownOpen((prev) => !prev);
                                                                }}
                                                                style={{
                                                                    position: "absolute", // ✅ changed from fixed
                                                                    right: "10px",
                                                                    top: "50%",
                                                                    transform: "translateY(-50%)", // ✅ centers it vertically
                                                                    cursor: "pointer",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    padding: "4px",
                                                                    color: "#6C757D",

                                                                }}
                                                            >
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    width="18"
                                                                    height="18"
                                                                    viewBox="0 0 18 18"
                                                                    fill="none"
                                                                    style={{
                                                                        transform: archivedParentBrandDropdownOpen ? 'rotate(0deg)' : 'rotate(180deg)',
                                                                        transition: 'transform 0.2s ease',
                                                                    }}
                                                                >
                                                                    <path
                                                                        d="M4.5 11.25L9 6.75L13.5 11.25"
                                                                        stroke="#212529"
                                                                        strokeWidth="2"
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                    />
                                                                </svg>
                                                            </div>
                                                        </div>

                                                        {/* Dropdown List */}
                                                        {archivedParentBrandDropdownOpen && (
                                                            <div
                                                                className="filter-options"
                                                                style={{
                                                                    marginTop: "8px",
                                                                    border: "1px solid #e9ecef",
                                                                    borderRadius: "8px",
                                                                    maxHeight: "200px",
                                                                    overflowY: "auto",
                                                                    backgroundColor: "#fff",
                                                                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                                                    transition: "all 0.2s ease-in-out",
                                                                }}
                                                                onClick={(e) => e.stopPropagation()} // ✅ prevents closing when clicking inside
                                                            >
                                                                {(() => {
                                                                    const filteredParents = [...new Set(allBrandsForFilter.map(b => b.brand_name).filter(Boolean))].sort((a, b) => a.localeCompare(b)).filter((parent) => {
                                                                        const term = archivedParentBrandSearchTerm.toLowerCase();
                                                                        if (parent.toLowerCase().includes(term)) return true;
                                                                        const brandObj = allBrandsForFilter.find(b => b.brand_name === parent);
                                                                        const hierarchy = brandObj?.brand_hierarchy || [];
                                                                        return hierarchy.some(h => h.name.toLowerCase().includes(term));
                                                                    });

                                                                    if (filteredParents.length === 0) {
                                                                        return (
                                                                            <div
                                                                                style={{
                                                                                    padding: "12px",
                                                                                    textAlign: "center",
                                                                                    color: "#6C757D",
                                                                                    fontSize: "14px",
                                                                                    fontFamily: "Montserrat",
                                                                                }}
                                                                            >
                                                                                No results found
                                                                            </div>
                                                                        );
                                                                    }

                                                                    return filteredParents.map((parent, index, filteredArray) => {
                                                                        const isSelected = tempArchivedParentBrands.includes(parent);
                                                                        const brandObj = allBrandsForFilter.find(b => b.brand_name === parent);
                                                                        const hierarchy = brandObj?.brand_hierarchy || [];
                                                                        const subtitle = hierarchy.length >= 1 ? hierarchy.map(b => b.name).join(' >> ') : null;

                                                                        return (
                                                                            <div
                                                                                key={index}
                                                                                style={{
                                                                                    display: "flex",
                                                                                    alignItems: "center",
                                                                                    justifyContent: "space-between",
                                                                                    padding: "8px 12px",
                                                                                    cursor: "pointer",
                                                                                    fontSize: "14px",
                                                                                    borderBottom:
                                                                                        index < filteredArray.length - 1
                                                                                            ? "1px solid #f1f1f1"
                                                                                            : "none",
                                                                                    backgroundColor: isSelected ? "#f8f9fa" : "transparent",
                                                                                }}
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    handleArchivedCheckboxChange(setTempArchivedParentBrands, parent)(
                                                                                        { target: { checked: !isSelected } }
                                                                                    );
                                                                                    setArchivedParentBrandSearchTerm("");
                                                                                }}
                                                                            >
                                                                                <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minWidth: 0 }}>
                                                                                    <div style={{ color: "#212529", fontWeight: "400", fontFamily: "Montserrat", fontStyle: 'normal', fontSize: '14px', lineHeight: "18px" }}>
                                                                                        <span
                                                                                            dangerouslySetInnerHTML={{
                                                                                                __html: highlightMatch(
                                                                                                    parent,
                                                                                                    archivedParentBrandSearchTerm
                                                                                                ),
                                                                                            }}
                                                                                        />
                                                                                    </div>
                                                                                    {subtitle && (
                                                                                        <div style={{ fontSize: '12px', color: '#6C757D', fontFamily: 'Montserrat', fontWeight: 400 }}>
                                                                                            {subtitle}
                                                                                        </div>
                                                                                    )}
                                                                                </div>

                                                                                {isSelected && (
                                                                                    <svg
                                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                                        width="20"
                                                                                        height="20"
                                                                                        viewBox="0 0 20 20"
                                                                                        fill="none"
                                                                                        style={{ flexShrink: 0, marginLeft: 8 }}
                                                                                    >
                                                                                        <path
                                                                                            d="M16.6668 5L7.50016 14.1667L3.3335 10"
                                                                                            stroke="#6C757D"
                                                                                            strokeWidth="2"
                                                                                            strokeLinecap="round"
                                                                                            strokeLinejoin="round"
                                                                                        />
                                                                                    </svg>
                                                                                )}
                                                                            </div>
                                                                        );
                                                                    });
                                                                })()}
                                                            </div>
                                                        )}
                                                    </div>

                                                </div>

                                                {/* Footer */}
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'flex-end',
                                                        alignItems: 'center',
                                                        gap: '50px',
                                                        padding: '20px 4px',
                                                    }}
                                                >
                                                    <button
                                                        onClick={() => {
                                                            setArchivedSearchParentBrand([]);
                                                            setTempArchivedParentBrands([]);
                                                            setArchivedParentBrandDropdownOpen(false);
                                                            // setArchivedFilterPopupOpen(false);
                                                        }}
                                                        style={{
                                                            background: 'none',
                                                            border: 'none',
                                                            // color: 'black',
                                                            // cursor: 'pointer',
                                                            // fontWeight: '500'
                                                            width: '140px',
                                                            color: '#000',
                                                            fontFamily: 'Montserrat',
                                                            fontSize: '12px',
                                                            fontStyle: 'normal',
                                                            lineHeight: 'normal',
                                                            fontWeight: '600',
                                                        }}
                                                    >
                                                        Clear
                                                    </button>

                                                    <div style={{ display: 'flex', gap: '8px' }}>
                                                        <button
                                                            onClick={handleCloseArchivedFilterPopup}
                                                            style={{
                                                                background: 'var(--Background-White, #FFF)',
                                                                borderRadius: '8px',
                                                                fontWeight: '500',
                                                                display: 'flex',
                                                                height: '34px',
                                                                minWidth: '100px',
                                                                padding: '10px',
                                                                justifyContent: 'center',
                                                                alignItems: 'center',
                                                                gap: '10px',
                                                                boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.10)',
                                                                border: '1px solid var(--navbar-dropdown-active, #212529)',
                                                                color: 'var(--navbar-dropdown-active, #212529)',
                                                                fontFamily: 'Montserrat',
                                                                fontSize: '12px',
                                                                fontStyle: 'normal',
                                                                lineHeight: 'normal',
                                                                fontWeight: '600',
                                                            }}
                                                        >
                                                            Cancel
                                                        </button>
                                                        <button
                                                            onClick={() => {
                                                                setArchivedSearchParentBrand(tempArchivedParentBrands);
                                                                setArchivedParentBrandDropdownOpen(false);
                                                                setArchivedFilterPopupOpen(false);
                                                            }}
                                                            style={{
                                                                display: 'flex',
                                                                height: '34px',
                                                                minWidth: '100px',
                                                                padding: '10px',
                                                                justifyContent: 'center',
                                                                alignItems: 'center',
                                                                gap: '10px',
                                                                background: 'var(--navbar-dropdown-active, #212529)',
                                                                borderRadius: '8px',
                                                                boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.10)',
                                                                fontFamily: 'Montserrat',
                                                                fontSize: '12px',
                                                                fontStyle: 'normal',
                                                                lineHeight: 'normal',
                                                                fontWeight: '600',
                                                                color: 'var(--Default-White, #FFF)',
                                                            }}
                                                        >
                                                            Filter
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                    <div className="table-wrapper" style={{ border: "none" }}>
                                        <DynamicTable
                                            columns={archivedColumns}
                                            data={archivedPageData}
                                            sortField={sortField}
                                            sortOrder={sortOrder}
                                            handleSort={handleSort}
                                            onRowClick={onRowClick}
                                            onActionClick={toggleDropdown}
                                            noImage={noImage}
                                            selectedIds={archivedSelectedIds}
                                            dropdownOpenId={dropdownOpenId}
                                            buttonRefs={buttonRefs}
                                            rowKey="brand_id"
                                            searchTerm={archivedSearchTerm}
                                            selectedParentBrands={archivedSearchParentBrand}
                                            emptySearchImg={emptySearchImg}
                                            noBrandImage={noBrandImage}
                                            emptyImage={archiveEmptyImage}
                                            emptyTitle={emptyArchivedTitle}
                                            emptyMessage={emptyArchivedMessage}
                                            showActions={true}
                                            stickyColumns={1}
                                            resizableColumns={true}
                                        />
                                        {dropdownOpenId !== null && archivedPageData.find(d => d.brand_id === dropdownOpenId) && (
                                            <div
                                                ref={dropdownRef}
                                                className="backdrop-cls"
                                                style={{
                                                    position: "absolute",
                                                    top: dropdownPosition.top,
                                                    left: dropdownPosition.left,
                                                    background: "white",
                                                    boxShadow: "0px 1px 4px 0px #0000001A",
                                                    zIndex: 1000,
                                                    minWidth: 152,
                                                    borderRadius: 8,
                                                }}
                                                onClick={e => e.stopPropagation()}
                                            >
                                                <div className="btn-align-forall">
                                                    <div className="common-for-all">
                                                        <button onClick={
                                                            () => {
                                                                const row = archivedPageData.find(d => d.brand_id === dropdownOpenId);
                                                                onRowClick(row);
                                                                setDropdownOpenId(null);
                                                            }
                                                        }>
                                                            View Details
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    {archivedTotalCount > 0 && (
                                        <div className="pagination">
                                            <div className="pagination-info">
                                                {` ${(archivedCurrentPage - 1) * PAGE_SIZE + 1} - ${Math.min(
                                                    archivedCurrentPage * PAGE_SIZE,
                                                    archivedTotalCount
                                                )} of ${archivedTotalCount}`}
                                            </div>

                                            <Pagination
                                                currentPage={archivedCurrentPage}
                                                totalPages={archivedTotalPages}
                                                onPageChange={setArchivedCurrentPage}
                                            />
                                        </div>



                                    )}
                                    {saveModalOpen && (
                                        <>
                                            <div className="drawer-overlay" />
                                            <div
                                                className="entity-drawer modal-popup-cls"
                                                ref={saveRef}
                                                style={{
                                                    maxWidth: 650,
                                                    margin: "0 auto",
                                                    background: "white",
                                                    borderRadius: 12,
                                                    zIndex: 1050,
                                                    padding: 24,
                                                    position: "fixed",
                                                    top: "50%",
                                                    left: "50%",
                                                    transform: "translate(-50%, -50%)",
                                                    boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                                                    height: "auto",
                                                    right: "auto",
                                                    overflow: "inherit",
                                                }}
                                            >
                                                <div className="drawer-header d-flex justify-content-end align-items-center pt-0 pe-0">
                                                    <button className="close-btn" onClick={() => setSaveModalOpen(false)}>
                                                        <X size={20} />
                                                    </button>
                                                </div>
                                                <h3 style={{ textAlign: "left", color: "#212529", fontSize: "20px", fontWeight: "600", lineHeight: "24px", fontFamily: "Montserrat", marginBottom: "5px" }}>New feature in Progress</h3>
                                                <p style={{ marginBottom: "0", textAlign: "left", color: "#6C757D", fontSize: "14px", fontWeight: "400", lineHeight: "20px", fontFamily: "Montserrat" }}>Work in Progress</p>
                                                <div className="drawer-footer" style={{ paddingTop: "10px" }}>
                                                    <button className="btn-save" onClick={handleSaveConfirm}>
                                                        OK
                                                    </button>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* Drawer for archived brands with combined General tab */}
                        {drawerOpen && selectedRow && (
                            <>
                                <div className="drawer-overlay" />
                                <div className="entity-drawer" ref={drawerRef}>
                                    <div className="drawer-header" style={{ backgroundColor: "#F8F9FA" }} >
                                        <div className="d-flex align-items-center gap-1">
                                            {previousBrand && (
                                                <button
                                                    className="back-btn"
                                                    onClick={handleBackToPreviousBrand}
                                                    style={{ backgroundColor: 'transparent', border: 'none', padding: 0, margin: 0 }}
                                                >
                                                    <ChevronLeft size={24} />
                                                </button>
                                            )}
                                            <h3>Brand Info</h3>
                                        </div>
                                        <button
                                            className="close-btn"
                                            onClick={() => {
                                                setDrawerOpen(false);
                                                setSelectedIds(ids => ids.filter(id => id !== selectedRow?.brand_id));
                                                setSelectedRow(null);
                                                setBrandStack([]);
                                            }}
                                        >
                                            <X size={24} />
                                        </button>
                                    </div>
                                    <div className="main-drawer-inner">
                                        <div
                                            className="drawer-title d-flex align-items-center justify-content-between"
                                            style={{
                                                borderBottom: "none",
                                                paddingBottom: "0px",
                                                boxShadow: "none",
                                                marginBottom: "0px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                                flexWrap: "nowrap",
                                                width: "100%",
                                            }}

                                        >      <div className='d-flex align-items-center'
                                            style={{
                                                flexWrap: 'nowrap',                     // ✅ allows wrapping
                                                alignItems: 'center',
                                                maxWidth: '70%',                      // ✅ prevent long name from pushing buttons

                                            }}

                                        >
                                                <img
                                                    src={selectedRow.original_logo_url || noImage}
                                                    alt="avatar"
                                                    className="avatar"
                                                    style={{
                                                        width: 40,
                                                        height: 40,
                                                        marginRight: 10,
                                                        verticalAlign: 'middle'
                                                    }}
                                                
                                                    onError={(e) => { e.target.src = noImage; }}
                                                />
                                                <h2 style={{ textTransform: 'none', }} className='pb-0'>{selectedRow?.brand_name}</h2>
                                            </div>
                                        </div>
                                        <div className="drawer-tabs"
                                            style={{
                                                padding: " 20px",           // optional: top/bottom 0, left/right 20px
                                                borderBottom: "1px solid #E9ECEF",
                                                gap: "20px",
                                                marginBottom: "20px",
                                            }}

                                        >
                                            <button
                                                className={drawerTab === 'general' ? 'active' : ''}
                                                onClick={() => setDrawerTab('general')}
                                            >
                                                General
                                            </button>
                                            <button
                                                className={drawerTab === 'additional-info' ? 'active' : ''}
                                                onClick={() => setDrawerTab('additional-info')}
                                            >
                                                Additional
                                            </button>
                                        </div>
                                        <div className="drawer-content">
                                            {drawerTab === 'general' && (
                                                <div className="tab-panel general-panel">

                                                    {/* ===== BASIC INFO CARD ===== */}
                                                    <div
                                                        className="card-section"
                                                        style={{
                                                            borderRadius: '12px',
                                                            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.08)', // subtle elevation
                                                            overflow: 'hidden',
                                                            marginBottom: '20px',
                                                            marginTop: '20px',
                                                        }}
                                                    >
                                                        {/* HEADER */}
                                                        <div
                                                            className="card-header"
                                                            style={{
                                                                backgroundColor: '#F8F9FA',
                                                                padding: '10px 16px',
                                                                fontFamily: 'Montserrat',
                                                                fontSize: '14px',
                                                                fontWeight: 600,
                                                                color: '#212529',
                                                            }}
                                                        >
                                                            Basic Info
                                                        </div>

                                                        {/* BODY */}
                                                        <div
                                                            className="card-body"
                                                            style={{
                                                                backgroundColor: '#FFFFFF',
                                                                padding: '16px',
                                                                display: 'grid',
                                                                gridTemplateColumns: 'repeat(2, 1fr)',
                                                                gap: '16px',
                                                            }}
                                                        >

                                                            <div className="field-block" style={{
                                                                borderBottom: 'none',
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                minHeight: '60px',
                                                                gridColumn: isBrandNameOverflowing(selectedRow.brand_name) ? '1 / -1' : '1',
                                                                gridRow: '1'
                                                            }}>
                                                                <div className="field-label">Brand Name</div>
                                                                <div className="field-value" style={{
                                                                    wordWrap: 'break-word',
                                                                    overflowWrap: 'break-word',
                                                                    whiteSpace: 'normal'
                                                                }}>
                                                                    {selectedRow.brand_name || <span style={{ color: '#ADB5BD' }}>NA</span>}
                                                                </div>
                                                            </div>
                                                            <div
                                                                className="field-block"
                                                                style={{
                                                                    borderBottom: 'none',
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    gridColumn: isBrandNameOverflowing(selectedRow.brand_name) ? '1' : '2',
                                                                    gridRow: isBrandNameOverflowing(selectedRow.brand_name) ? '2' : '1',
                                                                }}
                                                            >
                                                                <div className="field-label" style={{ marginBottom: '4px' }}>ID</div>
                                                                <div className="field-value" style={{ width: '100%', wordBreak: 'break-all' }}>

                                                                    {selectedRow.external_id || <span style={{ color: '#ADB5BD' }}>NA</span>}


                                                                </div>
                                                            </div>


                                                            {/* Open ID - full width */}
                                                            <div
                                                                className="field-block"
                                                                style={{
                                                                    borderBottom: 'none',
                                                                    padding: '9px 0',
                                                                    gridColumn: '1 / -1', // ✅ span both columns
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    alignItems: 'flex-start',
                                                                    width: '100%',
                                                                }}
                                                            >
                                                                <div className="field-label" style={{ marginBottom: '4px' }}>Open ID</div>
                                                                <div className="field-value" style={{ width: '100%', wordBreak: 'break-all' }}>
                                                                    {selectedRow.uuid ? (
                                                                        <div className="field-value d-flex align-items-center gap-2">
                                                                            <span
                                                                                style={{
                                                                                    color: '#2C7BE5',
                                                                                    cursor: 'pointer',
                                                                                    textDecoration: 'underline',
                                                                                }}
                                                                                onClick={() => handleCopy(selectedRow.uuid)}
                                                                            >
                                                                                {selectedRow.uuid}
                                                                                <Copy
                                                                                    size={13}
                                                                                    onClick={() => handleCopy(selectedRow.uuid)}
                                                                                    style={{ cursor: 'pointer', color: '#2C7BE5', marginLeft: '6px', }}
                                                                                />
                                                                            </span>
                                                                            {copied && (
                                                                                <span style={{ fontSize: '12px', color: '#2C7BE5' }}>
                                                                                    Copied!
                                                                                </span>
                                                                            )}
                                                                        </div>
                                                                    ) : (
                                                                        <span style={{ color: '#ADB5BD' }}>NA</span>
                                                                    )}
                                                                </div>
                                                            </div>


                                                            <div className="field-block"
                                                                style={{
                                                                    borderBottom: 'none',
                                                                    padding: '9px 0px',
                                                                    wordBreak: 'break-word',       // ✅ added
                                                                    overflowWrap: 'break-word',
                                                                    whiteSpace: 'normal',
                                                                }}

                                                            >
                                                                <div className="field-label">Created By</div>
                                                                <div className="field-value">{selectedRow.created_by_name || <span style={{ color: '#ADB5BD' }}>NA</span>}</div>
                                                            </div>

                                                            <div className="field-block"
                                                                style={{
                                                                    borderBottom: 'none',
                                                                    padding: '9px 0px',
                                                                    wordBreak: 'break-word',       // ✅ added
                                                                    overflowWrap: 'break-word',
                                                                    whiteSpace: 'normal',
                                                                }}

                                                            >
                                                                <div className="field-label">Created Time</div>
                                                                <div className="field-value">
                                                                    {formatDateTime(selectedRow.created_at) || <span style={{ color: '#ADB5BD' }}>NA</span>}
                                                                </div>
                                                            </div>

                                                            <div className="field-block"
                                                                style={{
                                                                    borderBottom: 'none',
                                                                    padding: '9px 0px',
                                                                    wordBreak: 'break-word',       // ✅ added
                                                                    overflowWrap: 'break-word',
                                                                    whiteSpace: 'normal',
                                                                }}

                                                            >
                                                                <div className="field-label">Last Modified By</div>
                                                                <div className="field-value">
                                                                    {selectedRow.modified_by_name || <span style={{ color: '#ADB5BD' }}>NA</span>}
                                                                </div>
                                                            </div>

                                                            <div className="field-block"
                                                                style={{
                                                                    borderBottom: 'none',
                                                                    padding: '9px 0px',
                                                                    wordBreak: 'break-word',       // ✅ added
                                                                    overflowWrap: 'break-word',
                                                                    whiteSpace: 'normal',
                                                                }}


                                                            >
                                                                <div className="field-label">Last Modified Time</div>
                                                                <div className="field-value">
                                                                    {formatDateTime(selectedRow.modified_at) || <span style={{ color: '#ADB5BD' }}>NA</span>}
                                                                </div>
                                                            </div>

                                                            <div className="field-block"
                                                                style={{
                                                                    borderBottom: 'none',
                                                                    padding: '9px 0px',
                                                                    wordBreak: 'break-word',       // ✅ added
                                                                    overflowWrap: 'break-word',
                                                                    whiteSpace: 'normal',
                                                                }}

                                                            >
                                                                <div className="field-label">Archived By</div>
                                                                <div className="field-value">
                                                                    {selectedRow.archived_by_name || <span style={{ color: '#ADB5BD' }}>NA</span>}
                                                                </div>
                                                            </div>

                                                            <div className="field-block"
                                                                style={{
                                                                    borderBottom: 'none',
                                                                    padding: '9px 0px',
                                                                    wordBreak: 'break-word',       // ✅ added
                                                                    overflowWrap: 'break-word',
                                                                    whiteSpace: 'normal',
                                                                }}

                                                            >
                                                                <div className="field-label">Archived Time</div>
                                                                <div className="field-value">
                                                                    {formatDateTime(selectedRow.archived_at) || <span style={{ color: '#ADB5BD' }}>NA</span>}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* ===== BUSINESS INFO CARD ===== */}
                                                    <div
                                                        className="card-section"
                                                        style={{
                                                            borderRadius: '12px',
                                                            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.08)',
                                                            overflow: 'hidden',
                                                        }}
                                                    >
                                                        <div
                                                            className="card-header"
                                                            style={{
                                                                backgroundColor: '#F8F9FA',
                                                                padding: '10px 16px',
                                                                fontFamily: 'Montserrat',
                                                                fontSize: '14px',
                                                                fontWeight: 600,
                                                                color: '#212529',
                                                            }}
                                                        >
                                                            Business Info
                                                        </div>

                                                        <div
                                                            className="card-body"
                                                            style={{
                                                                backgroundColor: '#FFFFFF',
                                                                padding: '16px',
                                                                display: 'grid',
                                                                gridTemplateColumns: 'repeat(2, 1fr)',
                                                                gap: '16px',
                                                            }}
                                                        >
                                                            <div className="field-block"
                                                                style={{
                                                                    borderBottom: 'none',
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    minHeight: '60px',
                                                                    gridColumn: isBrandNameOverflowing(selectedRow.parent_name) ? '1 / -1' : '1',
                                                                    gridRow: '1',
                                                                    padding: '9px 0px',
                                                                }}
                                                            >

                                                                <div className="field-label">Parent Brand</div>
                                                                <div className="field-value">
                                                                    {selectedRow.parent_name && selectedRow.parent_name !== <span style={{ color: '#ADB5BD' }}>NA</span> ? (
                                                                        (() => {
                                                                            const parentBrandObj = brandsData.find(
                                                                                (d) => d.brand_id === selectedRow.parent_brand
                                                                            );
                                                                            const parentLogo =
                                                                                parentBrandObj?.original_logo_url || noImage;

                                                                            return (
                                                                                <div className="d-flex align-items-center">
                                                                                    <img
                                                                                        src={parentLogo}
                                                                                        alt="parent brand logo"
                                                                                        className="avatar"
                                                                                        onError={(e) => {
                                                                                            e.target.onerror = null;
                                                                                            e.target.src = noImage;
                                                                                        }}
                                                                                        style={{
                                                                                            width: 32,
                                                                                            height: 32,
                                                                                            marginRight: 10,
                                                                                            verticalAlign: 'middle',
                                                                                        }}
                                                                                    />
                                                                                    <div className="d-flex align-items-center gap-1 me-3">
                                                                                        <span

                                                                                        >
                                                                                            {selectedRow.parent_name}
                                                                                        </span>

                                                                                    </div>
                                                                                </div>
                                                                            );
                                                                        })()
                                                                    ) : (
                                                                        <span style={{ color: '#ADB5BD' }}>NA</span>
                                                                    )}
                                                                </div>
                                                            </div>

                                                            <div className="field-block"
                                                                style={{
                                                                    borderBottom: 'none',
                                                                    padding: '9px 0px',
                                                                    wordBreak: 'break-word',       // ✅ added
                                                                    overflowWrap: 'break-word',
                                                                    whiteSpace: 'normal',
                                                                }}

                                                            >
                                                                <div className="field-label">Prefix</div>
                                                                <div className="field-value">{selectedRow.prefix || <span style={{ color: '#ADB5BD' }}>NA</span>}</div>
                                                            </div>

                                                            <div
                                                                className="field-block"
                                                                style={{
                                                                    borderBottom: 'none',
                                                                    padding: '9px 0',
                                                                    gridColumn: '1 / -1', // ✅ span both columns
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    alignItems: 'flex-start',
                                                                    width: '100%',
                                                                }}>
                                                                <div className="field-label" style={{ marginBottom: '4px' }}>Logo</div>
                                                                <div className="field-value" style={{ width: '100%', wordBreak: 'break-all' }}>
                                                                    <img
                                                                        src={selectedRow.original_logo_url || noImage}
                                                                        alt="avatar"
                                                                        className="avatar"
                                                                        style={{
                                                                            // maxWidth: 100,
                                                                            cursor: 'pointer',
                                                                            // borderRadius: '8px',
                                                                            height: 32,
                                                                            width: 32,
                                                                        }}
                                                                        onClick={() => setImageModalOpen(true)}
                                                                    
                                                                        onError={(e) => { e.target.src = noImage; }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            {imageModalOpen && (
                                                <>
                                                    <div className="drawer-overlay" style={{ zIndex: 1100 }} />
                                                    <div
                                                        className="image-modal"
                                                        style={{
                                                            position: 'fixed',
                                                            top: '50%',
                                                            left: '50%',
                                                            transform: 'translate(-50%, -50%)',
                                                            background: 'white',
                                                            borderRadius: '12px',
                                                            boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
                                                            zIndex: 1101,
                                                            maxWidth: '90%',
                                                            maxHeight: '90%',
                                                            overflow: 'auto'
                                                        }}
                                                    >
                                                        <div style={{ position: 'relative' }}>
                                                            <button
                                                                className="close-btn"
                                                                onClick={() => setImageModalOpen(false)}
                                                                style={{
                                                                    position: 'absolute',
                                                                    top: '10px',
                                                                    right: '10px',
                                                                    background: 'none',
                                                                    border: 'none',
                                                                    cursor: 'pointer'
                                                                }}
                                                            >
                                                                <X size={24} />
                                                            </button>
                                                            <img
                                                                src={selectedRow.original_logo_url || noImage}
                                                                alt="avatar"
                                                                style={{
                                                                    maxWidth: '100%',
                                                                    maxHeight: '80vh',
                                                                    display: 'block'
                                                                }}
                                                            
                                                                onError={(e) => { e.target.src = noImage; }}
                                                            />
                                                        </div>
                                                    </div>
                                                </>
                                            )}

                                            {drawerTab === 'additional-info' && (
                                                <div
                                                    className="card-section"
                                                    style={{
                                                        borderRadius: '12px',
                                                        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.08)',
                                                        overflow: 'hidden',
                                                        marginTop: '40px',
                                                    }}
                                                >
                                                    {/* ✅ Header: same style as Business Info */}
                                                    <div
                                                        className="card-header notes-preserve"
                                                        style={{
                                                            backgroundColor: '#F8F9FA',
                                                            padding: '10px 16px',
                                                            fontFamily: 'Montserrat',
                                                            fontSize: '14px',
                                                            fontWeight: 600,
                                                            color: '#212529',
                                                        }}
                                                    >
                                                        Notes
                                                    </div>

                                                    {/* ✅ Body: matches layout and spacing */}
                                                    <div
                                                        className="card-body"
                                                        style={{
                                                            backgroundColor: '#FFFFFF',
                                                            padding: '16px',
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            gap: '12px',
                                                            wordBreak: 'break-word',
                                                            overflowWrap: 'break-word',
                                                            whiteSpace: 'normal',
                                                        }}
                                                    >
                                                        <div className="field-block">
                                                            <div
                                                                className="field-value notes-preserve"
                                                                style={{
                                                                    background: '#FFFFFF',
                                                                    padding: '8px 0',
                                                                    fontSize: '13px',
                                                                    color: selectedRow.notes ? '#212529' : '#ADB5BD',
                                                                    minHeight: '24px',
                                                                }}
                                                            >
                                                                {selectedRow.notes || 'NA'}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                )}
            </div>

            <style>{`
              /* Matches Stock List's Action column width exactly. DynamicTable
                 already sets this to 56px via its <colgroup> when
                 resizableColumns is on, so this is belt-and-suspenders — but
                 kept explicit here for parity with Stock List's own stylesheet. */
              .entities-table .actionHeader {
                width: 56px;
                min-width: 56px;
                max-width: 56px;
              }

              /* Fixed-column shadows — anchored to the sticky column itself so
                 they stay correctly placed at any scroll offset, and spill onto
                 the scrollable content the fixed column is floating above. Only
                 shown while something is actually scrolled behind it. */
              .entities-table.is-scrolled-right th.actionHeader::before,
              .entities-table.is-scrolled-right td.actionColumn::before {
                content: "";
                position: absolute;
                left: -8px;
                top: 0;
                width: 8px;
                height: 100%;
                pointer-events: none;
                z-index: 1;
                background: linear-gradient(
                  to left,
                  rgba(0, 0, 0, 0.12),
                  rgba(0, 0, 0, 0)
                );
              }

              .entities-table.is-scrolled-left th:nth-child(1)::after,
              .entities-table.is-scrolled-left td:nth-child(1)::after {
                content: "";
                position: absolute;
                top: 0;
                right: -8px;
                width: 8px;
                height: 100%;
                pointer-events: none;
                z-index: 1;
                background: linear-gradient(
                  to right,
                  rgba(0, 0, 0, 0.12),
                  rgba(0, 0, 0, 0)
                );
              }

              /* Brand Name's cell clips via its own inner span (see render
                 above), so the outer td can safely allow overflow here without
                 losing text truncation — needed so the shadow above isn't cut
                 off by the td's own overflow:hidden. */
              .entities-table.is-scrolled-left td:nth-child(1) {
                overflow: visible !important;
              }

              /* Grip mark on each column's resize handle, so users can spot
                 where to drag without having to hover first. */
              .col-resize-handle::after {
                content: "";
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                height: 50%;
                left: 3px;
                width: 2px;
                background: #DEE2E6;
              }
            `}</style>
        </div>
    );
};